var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { b as removeClass$1, c as addClass$1 } from "./render-product-cards-C86dq60y.js";
function hasClass$1(el, className) {
  if (!el || typeof className !== "string") return false;
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return new RegExp("(^|\\s)" + className + "(\\s|$)").test(el.className);
  }
}
const JSbreakpoints = {
  smallMobile: 768,
  mobile: 1024,
  tablet: 1280
  // optional: define more for consistency
};
function onResizeDebounced(callback, delay = 200) {
  let resizeTimeout;
  const handler = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      callback();
    }, delay);
  };
  window.addEventListener("resize", handler);
}
function createLinkFromTemplate(templateKey, { text, url, id, additionalClasses = "" }) {
  var _a, _b;
  const rawHTML = (_b = (_a = window._JK) == null ? void 0 : _a.links) == null ? void 0 : _b[templateKey];
  if (!rawHTML) return "";
  const temp = document.createElement("div");
  temp.innerHTML = rawHTML.trim();
  const linkEl = temp.querySelector("a");
  if (!linkEl) return "";
  linkEl.textContent = text;
  if (url) linkEl.href = url;
  if (id) linkEl.id = id;
  if (additionalClasses) linkEl.classList.add(...additionalClasses.split(" "));
  return linkEl.outerHTML;
}
function formatMoney(cents, format2, currency = "$") {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (format2) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_with_currency":
      value = currency + formatWithDelimiters(cents, 2);
      break;
    case "amount_with_currency_without_trailing_zeros":
      value = currency + formatWithDelimiters(cents, 2);
      if (value.indexOf(".00") !== -1) {
        value = value.replace(".00", "");
      }
      break;
    case "amount_with_currency_round_up":
      if (cents % 100 !== 0) {
        cents = Math.ceil(cents / 100) * 100;
      }
      value = currency + formatWithDelimiters(cents, 2);
      if (value.indexOf(".00") !== -1) {
        value = value.replace(".00", "");
      }
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return value;
}
const lazyLoadImages = (root = document) => {
  const lazyImages = root.querySelectorAll(".custom__lazy");
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const image = entry.target;
        const src = image.getAttribute("data-src") || image.getAttribute("src");
        if (src)
          image.src = src;
        image.onload = () => {
          image.classList.add("custom__lazy-loaded");
          image.classList.remove("custom__lazy");
        };
        observer.unobserve(image);
      }
    });
  }, {
    rootMargin: "0px 0px 100px 0px"
    // Start loading slightly before visible
  });
  lazyImages.forEach((image) => {
    imageObserver.observe(image);
  });
};
const _UniversalModal = class _UniversalModal {
  constructor(modalSelector, openSelector, closeSelector, root = document, forceRebind = false) {
    var _a, _b, _c, _d, _e, _f;
    const instanceKey = `${modalSelector}|${openSelector}|${closeSelector}`;
    if (_UniversalModal.instances.has(instanceKey)) {
      if (!forceRebind) {
        console.warn(`[UniversalModal] Instance already exists for: ${instanceKey}`);
      } else {
        _UniversalModal.instances.get(instanceKey).destroy();
      }
    }
    this.isOpen = false;
    this.modalSelector = modalSelector;
    this.openSelector = openSelector;
    this.closeSelector = closeSelector;
    this.rootInstance = root;
    this.instanceKey = instanceKey;
    this.modal = (_b = (_a = this.rootInstance) == null ? void 0 : _a.querySelector) == null ? void 0 : _b.call(_a, modalSelector);
    this.openModalBtns = (_c = this.rootInstance) == null ? void 0 : _c.querySelectorAll(this.openSelector);
    this.closeModalBtn = (_d = this.rootInstance) == null ? void 0 : _d.querySelector(this.closeSelector);
    this.open = this.open.bind(this);
    this._handleClose = this.close.bind(this);
    this._handleBackdrop = this.handleBackdropClick.bind(this);
    this._handleEscape = this.handleKeydown.bind(this);
    this._handleDocumentClick = this._handleDocumentClick.bind(this);
    if (this.modal) {
      (_e = this.rootInstance) == null ? void 0 : _e.addEventListener("click", this._handleDocumentClick);
      (_f = this.closeModalBtn) == null ? void 0 : _f.addEventListener("click", this._handleClose);
      window.addEventListener("click", this._handleBackdrop);
      window.addEventListener("keydown", this._handleEscape);
    } else {
      console.warn(`[UniversalModal] Modal element not found: ${modalSelector}`);
    }
    _UniversalModal.instances.set(instanceKey, this);
  }
  _handleDocumentClick(e) {
    const triggerBtn = e.target.closest(this.openSelector);
    if (triggerBtn) {
      e.stopPropagation();
      e.preventDefault();
      this.open(e, triggerBtn);
      const button = triggerBtn.closest("button");
      if (button) {
        button.setAttribute("aria-expanded", "true");
      }
    }
  }
  open(e, triggerElement = null) {
    var _a, _b, _c;
    const element = triggerElement || (e == null ? void 0 : e.target);
    const data = (element == null ? void 0 : element.dataset) || {};
    this.isOpen = true;
    const event = new CustomEvent("modal:shown", {
      detail: { ...data, modal: this.modal }
    });
    (_a = this.modal) == null ? void 0 : _a.dispatchEvent(event);
    element == null ? void 0 : element.setAttribute("aria-expanded", true);
    (_b = this.modal) == null ? void 0 : _b.setAttribute("aria-hidden", "false");
    (_c = this.modal) == null ? void 0 : _c.removeAttribute("inert");
    this.showModal();
    setTimeout(() => {
      if (this.closeModalBtn) {
        this.closeModalBtn.setAttribute("aria-expanded", true);
        this.closeModalBtn.classList.add("opacity-100");
        this.closeModalBtn.classList.remove("opacity-0");
      }
    }, 500);
    document.body.classList.add("ui-active");
    document.documentElement.classList.add("overflow-hidden");
    document.body.classList.add("overflow-hidden");
  }
  close(source = "manual") {
    var _a, _b;
    if (this.closeModalBtn) {
      this.closeModalBtn.focus();
      this.closeModalBtn.setAttribute("aria-expanded", false);
      this.closeModalBtn.classList.remove("opacity-100");
      this.closeModalBtn.classList.add("opacity-0");
    }
    this.isOpen = false;
    this.openModalBtns = (_a = this.rootInstance) == null ? void 0 : _a.querySelectorAll(this.openSelector);
    this.hideModal();
    const event = new CustomEvent("modal:closed", {
      detail: {
        source,
        modal: this.modal
      }
    });
    (_b = this.modal) == null ? void 0 : _b.dispatchEvent(event);
    setTimeout(() => {
      var _a2, _b2;
      (_a2 = this.modal) == null ? void 0 : _a2.setAttribute("aria-hidden", "true");
      (_b2 = this.modal) == null ? void 0 : _b2.setAttribute("inert", "");
      this.openModalBtns.forEach((openModalBtn) => {
        openModalBtn.setAttribute("aria-expanded", false);
      });
    }, 300);
    document.body.classList.remove("ui-active", "overflow-hidden");
    document.documentElement.classList.remove("overflow-hidden");
    document.activeElement.blur();
  }
  handleBackdropClick(e) {
    var _a;
    e.stopPropagation();
    if (e.target === this.modal && this.modal.contains(e.target)) {
      const customEvent = new CustomEvent("modal:closed", {
        detail: {
          source: "backdrop",
          modal: this.modal
        }
      });
      (_a = this.modal) == null ? void 0 : _a.dispatchEvent(customEvent);
      this.close("backdrop");
    }
  }
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }
  showModal() {
    var _a, _b;
    (_a = this.modal) == null ? void 0 : _a.classList.add("flex");
    (_b = this.modal) == null ? void 0 : _b.classList.remove("hidden");
    setTimeout(() => {
      var _a2;
      (_a2 = this.modal) == null ? void 0 : _a2.classList.remove("opacity-0", "w-0");
    }, 10);
  }
  hideModal() {
    var _a, _b;
    if (!((_a = this.modal) == null ? void 0 : _a.classList.contains("custom-modal"))) {
      (_b = this.modal) == null ? void 0 : _b.classList.add("opacity-0");
      setTimeout(() => {
        var _a2, _b2;
        (_a2 = this.modal) == null ? void 0 : _a2.classList.add("hidden", "w-0");
        (_b2 = this.modal) == null ? void 0 : _b2.classList.remove("flex");
      }, 300);
    }
  }
  refresh(root = document) {
    var _a;
    this.destroy();
    this.modal = root == null ? void 0 : root.querySelector(this.modalSelector);
    this.openModalBtns = root == null ? void 0 : root.querySelectorAll(this.openSelector);
    this.closeModalBtn = root == null ? void 0 : root.querySelector(this.closeSelector);
    this.openModalBtns.forEach((openModalBtn) => {
      openModalBtn.addEventListener("click", this._handleDocumentClick);
    });
    (_a = this.closeModalBtn) == null ? void 0 : _a.addEventListener("click", this._handleClose);
    window.addEventListener("click", this._handleBackdrop);
    window.addEventListener("keydown", this._handleEscape);
    _UniversalModal.instances.set(this.instanceKey, this);
  }
  destroy() {
    var _a;
    this.openModalBtns.forEach((openModalBtn) => {
      openModalBtn.removeEventListener("click", this._handleDocumentClick);
    });
    (_a = this.closeModalBtn) == null ? void 0 : _a.removeEventListener("click", this._handleClose);
    window.removeEventListener("click", this._handleBackdrop);
    window.removeEventListener("keydown", this._handleEscape);
    _UniversalModal.instances.delete(this.instanceKey);
  }
};
__publicField(_UniversalModal, "instances", /* @__PURE__ */ new Map());
let UniversalModal = _UniversalModal;
function Listeners() {
  this.entries = [];
}
Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element, event, fn });
  element.addEventListener(event, fn);
};
Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);
  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });
  return result[0] || null;
}
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);
  var optionArray = [];
  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });
  return optionArray;
}
function _validateProductStructure(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + " is not an object.");
  }
  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + " is empty.");
  }
}
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + " is not an array.");
  }
  if (collection.length === 0) {
    return [];
  }
  if (collection[0].hasOwnProperty("name")) {
    if (typeof collection[0].name !== "string") {
      throw new TypeError(
        "Invalid value type passed for name of option " + collection[0].name + ". Value should be string."
      );
    }
  } else {
    throw new Error(collection[0] + "does not contain name key.");
  }
}
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === "object") {
    throw new Error(options + "is not a valid array of options.");
  }
}
var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};
function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, "$1" + id);
  } else if (/\?/.test(url)) {
    return url.concat("&variant=").concat(id);
  }
  return url.concat("?variant=").concat(id);
}
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);
  options = options || {};
  this._listeners = new Listeners();
  this._listeners.add(
    this.element,
    "submit",
    this._onSubmit.bind(this, options)
  );
  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );
  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );
  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2];
    return item;
  });
};
ProductForm.prototype.variant = function() {
  return getVariantFromSerializedArray(this.product, this.options());
};
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(propertyName) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2];
    return name;
  });
  return Object.entries(properties).length === 0 ? null : properties;
};
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
};
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);
  if (!idInputElement) {
    idInputElement = document.createElement("input");
    idInputElement.type = "hidden";
    idInputElement.name = "id";
    this.element.appendChild(idInputElement);
  }
  idInputElement.value = value.toString();
};
ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();
  if (event.dataset.variant) {
    this._setIdInputValue(event.dataset.variant.id);
  }
  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};
ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === "undefined") {
    return Function.prototype;
  }
  return (function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }).bind(this);
};
ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );
  return elements.map(
    (function(element) {
      this._listeners.add(element, "change", this._onFormEvent(cb));
      return element;
    }).bind(this)
  );
};
ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};
function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (input.checked || // If input is a checked (means type radio or checkbox)
    input.type !== "radio" && input.type !== "checkbox") {
      options.push(transform({ name: input.name, value: input.value }));
    }
    return options;
  }, []);
}
function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (input.checked || // If input is a checked (means type radio or checkbox)
    input.type !== "radio" && input.type !== "checkbox") {
      properties[transform(input.name)] = input.value;
    }
    return properties;
  }, {});
}
function _validateProductObject(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + " is not an object.");
  }
  if (typeof product.variants[0].options === "undefined") {
    throw new TypeError(
      "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
    );
  }
  return product;
}
function trackRecentlyViewed() {
  var _a;
  const key = "recently-viewed";
  const max2 = 9;
  const productData = {
    id: SDG.Data.productJson.id,
    handle: SDG.Data.productJson.handle,
    requires_gate: ((_a = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a.isProductGated) === true
  };
  const productList = [];
  productList.push(productData);
  let jsonResp;
  let jsonRespArr;
  const currProductId = productData.id;
  const productDataString = JSON.stringify(productList);
  const localData = localStorage.getItem(key);
  if (localData === null) {
    localStorage.setItem(key, productDataString);
  } else if (localData) {
    const currProductData = localStorage.getItem(key);
    const currProductCount = (currProductData.match(/id/g) || []).length;
    const currProductAlreadyInList = currProductData.includes(currProductId);
    if (currProductAlreadyInList) {
      const productData2 = JSON.parse(localStorage.getItem(key));
      const filteredProductData = productData2.filter((item) => item.id !== currProductId);
      const newProductData = filteredProductData.concat(productList);
      localStorage.setItem(key, JSON.stringify(newProductData));
    } else {
      jsonResp = JSON.parse(currProductData);
      if (currProductCount >= max2) {
        jsonResp == null ? void 0 : jsonResp.shift();
      }
      jsonRespArr = jsonResp.concat(productList);
      localStorage.setItem(key, JSON.stringify(jsonRespArr));
    }
  }
}
function showAddToBagModal({ variant, lineItem, color, currentQty }, root = document) {
  var _a, _b;
  const modal = root.getElementById("universal-modal-add-to-bag");
  const content = modal == null ? void 0 : modal.querySelector("#add-to-bag-content");
  if (!modal || !content || !variant) return;
  _JK.helpers.removeClass(modal, "hidden");
  const bag = (_JK == null ? void 0 : _JK.Bag) || {};
  const lineItemQuantity = Number(bag.lastQuantity) || 1;
  const pricePerItem = lineItem.final_line_price / lineItem.quantity;
  const totalPrice = pricePerItem * lineItemQuantity;
  const selectedOptionValue = ((_a = lineItem.options_with_values[0]) == null ? void 0 : _a.value) || "";
  const newQty = Number(currentQty) + Number(lineItemQuantity);
  const optionsText = [color, selectedOptionValue].filter(Boolean).join(", ");
  modal.querySelector(".js-item-added-to-cart-count").innerText = `${lineItemQuantity} Item${lineItemQuantity > 1 ? "s" : ""} Added to Cart`;
  if (lineItem.image) {
    modal.querySelector(".js-item-added-to-cart-image").src = lineItem.image;
  }
  modal.querySelector(".js-item-added-to-cart-image").alt = `${lineItem.product_title} - ${selectedOptionValue || "Image"}`;
  modal.querySelector(".js-add-modal-product-title").innerText = lineItem.product_title;
  const cta = modal.querySelector(".js-add-bag-modal-cart-cta");
  if (cta) {
    cta.innerText = cta.innerText.replace(/\s\(\d+\)$/, "") + ` (${newQty})`;
  }
  modal.querySelector(".js-add-modal-subtotal").innerText = formatMoney(totalPrice, "amount_with_currency_without_trailing_zeros");
  modal.querySelector(".js-add-modal-item-price").innerText = formatMoney(pricePerItem, "amount_with_currency_without_trailing_zeros");
  const optionsEl = modal.querySelector(".js-add-modal-options");
  if (optionsEl) {
    if (optionsText) {
      optionsEl.innerText = optionsText;
      removeClass$1(optionsEl, "hidden");
    } else {
      addClass$1(optionsEl, "hidden");
    }
  }
  addClass$1(modal, "flex");
  removeClass$1(modal, "opacity-0", "pointer-events-none", "hidden");
  removeClass$1(content, "translate-y-full", "opacity-0");
  addClass$1(content, "translate-y-0", "opacity-100");
  const handleOutsideClick = (e) => {
    if (!content.contains(e.target)) hideAddToBagModal(root);
  };
  const handleEscapeKey = (e) => {
    if (e.key === "Escape") hideAddToBagModal(root);
  };
  const handleCloseClick = () => hideAddToBagModal(root);
  modal._outsideClick = handleOutsideClick;
  modal._escapeKey = handleEscapeKey;
  modal._closeClick = handleCloseClick;
  clearTimeout(modal._hideTimeout);
  if ((_b = _JK == null ? void 0 : _JK.config) == null ? void 0 : _b.auto_enable_add_to_bag_close) {
    modal._hideTimeout = setTimeout(() => hideAddToBagModal(root), 3e3);
  }
  modal.addEventListener("click", handleOutsideClick);
  window.addEventListener("keydown", handleEscapeKey);
  const closeBtn = root.querySelector("#close-add-to-bag-modal");
  if (closeBtn) closeBtn.addEventListener("click", handleCloseClick);
}
function hideAddToBagModal(root = document) {
  const modal = root == null ? void 0 : root.getElementById("universal-modal-add-to-bag");
  const content = root == null ? void 0 : root.getElementById("add-to-bag-content");
  if (!modal || !content) return;
  if (modal._outsideClick) modal.removeEventListener("click", modal._outsideClick);
  if (modal._escapeKey) window.removeEventListener("keydown", modal._escapeKey);
  if (modal._closeClick) {
    const closeBtn = root == null ? void 0 : root.getElementById("close-add-to-bag-modal");
    if (closeBtn) closeBtn.removeEventListener("click", modal._closeClick);
  }
  clearTimeout(modal._hideTimeout);
  root.querySelectorAll(".shopify-product-form .js-input-qty").forEach((input) => input.value = 1);
  root.querySelectorAll(".shopify-product-form .js-text-qty").forEach((el) => el.innerText = 1);
  removeClass$1(content, "opacity-100", "translate-y-0");
  addClass$1(content, "translate-y-full", "opacity-0");
  setTimeout(() => {
    addClass$1(modal, "opacity-0", "pointer-events-none", "hidden");
    removeClass$1(modal, "flex");
  }, 300);
}
class JKCart {
  constructor(onCartChange = null) {
    this.cartUrl = "/cart.js";
    this.cartPageUrl = "/cart";
    this.addUrl = "/cart/add.js";
    this.updateUrl = "/cart/update.js";
    this.clearUrl = "/cart/clear.js";
    this.headers = {
      "Content-Type": "application/json",
      "Accept": "application/json"
    };
    this.onCartChange = onCartChange;
  }
  // Internal helper to trigger a UI update if a callback was provided
  triggerCartChange() {
    if (typeof this.onCartChange === "function") {
      this.onCartChange();
    }
  }
  // Fetch the current cart state
  async fetchCart() {
    try {
      const response = await fetch(this.cartUrl, {
        method: "GET",
        headers: this.headers
      });
      const json = await response.json();
      if (!window._JK) window._JK = {};
      if (_JK.Bag && typeof _JK.Bag === "object") {
        Object.assign(_JK.Bag, json);
      } else {
        _JK.Bag = json;
      }
      return json;
    } catch (err) {
      console.warn("[JKCart] fetchCart failed", err);
      throw err;
    }
  }
  // Add a single item to the cart
  async addItem(variantId, quantity = 1, properties = {}, sellingPlanId = null) {
    const body = JSON.stringify({
      id: variantId,
      quantity,
      properties,
      ...sellingPlanId && { selling_plan: sellingPlanId }
    });
    const response = await fetch(this.addUrl, {
      method: "POST",
      headers: this.headers,
      body
    }).then((res) => res.json());
    const event = new CustomEvent("jkCart:added-item", {
      detail: {
        addedItem: response
      }
    });
    window.dispatchEvent(event);
    this.triggerCartChange();
    return response;
  }
  // Add multiple items to the cart at once
  async addItems(items) {
    const formattedItems = items.map((item) => ({
      id: item.variantId,
      quantity: item.quantity || 1,
      properties: item.properties || {},
      ...item.sellingPlanId && { selling_plan: item.sellingPlanId }
    }));
    const body = JSON.stringify({ items: formattedItems });
    const response = await fetch(this.addUrl, {
      method: "POST",
      headers: this.headers,
      body
    }).then((res) => res.json());
    const event = new CustomEvent("jkCart:added-items", {
      detail: {
        addedItem: response
      }
    });
    window.dispatchEvent(event);
    this.triggerCartChange();
    return response;
  }
  // Update the quantity or selling plan of a single line item
  async updateItem(lineItemId, quantity, sellingPlanId = null) {
    const body = sellingPlanId ? JSON.stringify({
      updates: {
        [lineItemId]: {
          quantity,
          selling_plan: sellingPlanId
        }
      }
    }) : JSON.stringify({
      updates: {
        [lineItemId]: quantity
      }
    });
    const response = await fetch(this.updateUrl, {
      method: "POST",
      headers: this.headers,
      body
    }).then((res) => res.json());
    const event = new CustomEvent("jkCart:updated-item", {
      detail: {
        lineItemId,
        updatedItem: response
      }
    });
    window.dispatchEvent(event);
    this.triggerCartChange();
    return response;
  }
  // Update multiple line items in a single request
  async updateItems(updates) {
    const formattedUpdates = Object.fromEntries(
      updates.map(({ lineItemId, quantity, sellingPlanId }) => [
        lineItemId,
        sellingPlanId ? { quantity, selling_plan: sellingPlanId } : quantity
      ])
    );
    const body = JSON.stringify({ updates: formattedUpdates });
    const response = await fetch(this.updateUrl, {
      method: "POST",
      headers: this.headers,
      body
    }).then((res) => res.json());
    const event = new CustomEvent("jkCart:updated-items", {
      detail: {
        updatedItem: response
      }
    });
    window.dispatchEvent(event);
    this.triggerCartChange();
    return response;
  }
  // Remove a single line item from the cart
  async removeItem(lineItemId) {
    const response = await this.updateItem(lineItemId, 0);
    const event = new CustomEvent("jkCart:removed-item", {
      detail: {
        deletedItem: response
      }
    });
    window.dispatchEvent(event);
    this.triggerCartChange();
    return response;
  }
  // Clear all items from the cart
  async clearCart() {
    const response = await fetch(this.clearUrl, {
      method: "POST",
      headers: this.headers
    }).then((res) => res.json());
    this.triggerCartChange();
    return response;
  }
  // Fetch specific cart sections by section name
  async fetchSections(sections, template) {
    return fetch(`${this.cartPageUrl}?sections=${sections == null ? void 0 : sections.join(",")}&view=${template}`, {
      headers: { "Accept": "text/html" }
    }).then((response) => response.json());
  }
}
function productSwatches(root = document) {
  const swatchImgs = root.querySelectorAll(".js-swatch-image");
  swatchImgs.forEach((img) => {
    const swatchParent = img.closest(".js-swatch");
    if (!swatchParent) return;
    const spinner = swatchParent.querySelector(".animate-spin");
    const hideSpinner = () => {
      if (spinner) spinner.classList.add("hidden");
    };
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add("opacity-100");
      hideSpinner();
    } else {
      img.addEventListener("load", () => {
        img.classList.add("opacity-100");
        hideSpinner();
      });
      img.addEventListener("error", () => {
        img.classList.add("hidden");
        hideSpinner();
      });
    }
  });
  const hexSwatches = root.querySelectorAll(".js-hex-swatch");
  hexSwatches.forEach((div) => {
    const container = div.closest(".js-swatch");
    const spinner = container == null ? void 0 : container.querySelector(".animate-spin");
    setTimeout(() => {
      div.classList.add("opacity-100");
      if (spinner) spinner.classList.add("hidden");
    }, 100);
  });
  const swatchLinks = root.querySelectorAll(".swatch--link[data-color]");
  swatchLinks.forEach((link) => {
    if (link.dataset.colorHoverBound === "true") return;
    link.dataset.colorHoverBound = "true";
    const colorName = (link.dataset.color || "").trim();
    if (!colorName) return;
    const colorSection = link.closest("section");
    const currentColorEl = colorSection == null ? void 0 : colorSection.querySelector(".js-current-color");
    if (!currentColorEl) return;
    if (currentColorEl.dataset.defaultColorSet !== "true") {
      currentColorEl.dataset.defaultColor = currentColorEl.textContent.trim();
      currentColorEl.dataset.defaultColorSet = "true";
    }
    const previewColor = () => {
      currentColorEl.textContent = colorName;
    };
    const resetColor = () => {
      currentColorEl.textContent = currentColorEl.dataset.defaultColor ?? "";
    };
    link.addEventListener("mouseenter", previewColor);
    link.addEventListener("mouseleave", resetColor);
    link.addEventListener("focus", previewColor);
    link.addEventListener("blur", resetColor);
  });
}
function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var SCROLLING = 5;
var DRAGGING = 6;
var DESTROYED = 7;
var STATES = {
  CREATED,
  MOUNTED,
  IDLE,
  MOVING,
  SCROLLING,
  DRAGGING,
  DESTROYED
};
function empty(array) {
  array.length = 0;
}
function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply(func) {
  return func.bind.apply(func, [null].concat(slice(arguments, 1)));
}
var nextTick = setTimeout;
var noop = function noop2() {
};
function raf(func) {
  return requestAnimationFrame(func);
}
function typeOf(type, subject) {
  return typeof subject === type;
}
function isObject(subject) {
  return !isNull(subject) && typeOf("object", subject);
}
var isArray = Array.isArray;
var isFunction = apply(typeOf, "function");
var isString = apply(typeOf, "string");
var isUndefined = apply(typeOf, "undefined");
function isNull(subject) {
  return subject === null;
}
function isHTMLElement(subject) {
  try {
    return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
  } catch (e) {
    return false;
  }
}
function toArray(value) {
  return isArray(value) ? value : [value];
}
function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}
function includes(array, value) {
  return array.indexOf(value) > -1;
}
function push(array, items) {
  array.push.apply(array, toArray(items));
  return array;
}
function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, function(name) {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}
function addClass(elm, classes) {
  toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
}
function append(parent, children2) {
  forEach(children2, parent.appendChild.bind(parent));
}
function before(nodes, ref) {
  forEach(nodes, function(node) {
    var parent = (ref || node).parentNode;
    if (parent) {
      parent.insertBefore(node, ref);
    }
  });
}
function matches(elm, selector) {
  return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function children(parent, selector) {
  var children2 = parent ? slice(parent.children) : [];
  return selector ? children2.filter(function(child2) {
    return matches(child2, selector);
  }) : children2;
}
function child(parent, selector) {
  return selector ? children(parent, selector)[0] : parent.firstElementChild;
}
var ownKeys = Object.keys;
function forOwn(object, iteratee, right) {
  if (object) {
    (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function(key) {
      key !== "__proto__" && iteratee(object[key], key);
    });
  }
  return object;
}
function assign(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      object[key] = source[key];
    });
  });
  return object;
}
function merge(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      if (isArray(value)) {
        object[key] = value.slice();
      } else if (isObject(value)) {
        object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
      } else {
        object[key] = value;
      }
    });
  });
  return object;
}
function omit(object, keys) {
  forEach(keys || ownKeys(object), function(key) {
    delete object[key];
  });
}
function removeAttribute(elms, attrs) {
  forEach(elms, function(elm) {
    forEach(attrs, function(attr) {
      elm && elm.removeAttribute(attr);
    });
  });
}
function setAttribute(elms, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, function(value2, name) {
      setAttribute(elms, name, value2);
    });
  } else {
    forEach(elms, function(elm) {
      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}
function create(tag, attrs, parent) {
  var elm = document.createElement(tag);
  if (attrs) {
    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
  }
  parent && append(parent, elm);
  return elm;
}
function style(elm, prop, value) {
  if (isUndefined(value)) {
    return getComputedStyle(elm)[prop];
  }
  if (!isNull(value)) {
    elm.style[prop] = "" + value;
  }
}
function display(elm, display2) {
  style(elm, "display", display2);
}
function focus(elm) {
  elm["setActive"] && elm["setActive"]() || elm.focus({
    preventScroll: true
  });
}
function getAttribute(elm, attr) {
  return elm.getAttribute(attr);
}
function hasClass(elm, className) {
  return elm && elm.classList.contains(className);
}
function rect(target) {
  return target.getBoundingClientRect();
}
function remove(nodes) {
  forEach(nodes, function(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}
function parseHtml(html) {
  return child(new DOMParser().parseFromString(html, "text/html").body);
}
function prevent(e, stopPropagation) {
  e.preventDefault();
  if (stopPropagation) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
function query(parent, selector) {
  return parent && parent.querySelector(selector);
}
function queryAll(parent, selector) {
  return selector ? slice(parent.querySelectorAll(selector)) : [];
}
function removeClass(elm, classes) {
  toggleClass(elm, classes, false);
}
function timeOf(e) {
  return e.timeStamp;
}
function unit(value) {
  return isString(value) ? value : value ? value + "px" : "";
}
var PROJECT_CODE = "splide";
var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
function assert(condition, message) {
  if (!condition) {
    throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
  }
}
var min = Math.min, max = Math.max, floor = Math.floor, ceil = Math.ceil, abs = Math.abs;
function approximatelyEqual(x, y, epsilon) {
  return abs(x - y) < epsilon;
}
function between(number, x, y, exclusive) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function clamp(number, x, y) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return min(max(minimum, number), maximum);
}
function sign(x) {
  return +(x > 0) - +(x < 0);
}
function format(string, replacements) {
  forEach(replacements, function(replacement) {
    string = string.replace("%s", "" + replacement);
  });
  return string;
}
function pad(number) {
  return number < 10 ? "0" + number : "" + number;
}
var ids = {};
function uniqueId(prefix) {
  return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
}
function EventBinder() {
  var listeners = [];
  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function(target, event, namespace) {
      var isEventTarget = "addEventListener" in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }
  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function(target, event, namespace) {
      listeners = listeners.filter(function(listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }
        return true;
      });
    });
  }
  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;
    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles,
        detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }
    target.dispatchEvent(e);
    return e;
  }
  function forEachEvent(targets, events, iteratee) {
    forEach(targets, function(target) {
      target && forEach(events, function(events2) {
        events2.split(" ").forEach(function(eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }
  function destroy() {
    listeners.forEach(function(data) {
      data[4]();
    });
    empty(listeners);
  }
  return {
    bind,
    unbind,
    dispatch,
    destroy
  };
}
var EVENT_MOUNTED = "mounted";
var EVENT_READY = "ready";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_CLICK = "click";
var EVENT_ACTIVE = "active";
var EVENT_INACTIVE = "inactive";
var EVENT_VISIBLE = "visible";
var EVENT_HIDDEN = "hidden";
var EVENT_REFRESH = "refresh";
var EVENT_UPDATED = "updated";
var EVENT_RESIZE = "resize";
var EVENT_RESIZED = "resized";
var EVENT_DRAG = "drag";
var EVENT_DRAGGING = "dragging";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_OVERFLOW = "overflow";
var EVENT_DESTROY = "destroy";
var EVENT_ARROWS_MOUNTED = "arrows:mounted";
var EVENT_ARROWS_UPDATED = "arrows:updated";
var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
var EVENT_PAGINATION_UPDATED = "pagination:updated";
var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
var EVENT_AUTOPLAY_PLAY = "autoplay:play";
var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
var EVENT_SLIDE_KEYDOWN = "sk";
var EVENT_SHIFTED = "sh";
var EVENT_END_INDEX_CHANGED = "ei";
function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder();
  function on(events, callback) {
    binder.bind(bus, toArray(events).join(" "), function(e) {
      callback.apply(callback, isArray(e.detail) ? e.detail : []);
    });
  }
  function emit(event) {
    binder.dispatch(bus, event, slice(arguments, 1));
  }
  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY, binder.destroy);
  }
  return assign(binder, {
    bus,
    on,
    off: apply(binder.unbind, bus),
    emit
  });
}
function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;
  function update() {
    if (!paused) {
      rate = interval ? min((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);
      if (rate >= 1) {
        onInterval();
        startTime = now();
        if (limit && ++count >= limit) {
          return pause();
        }
      }
      id = raf(update);
    }
  }
  function start(resume) {
    resume || cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    id = raf(update);
  }
  function pause() {
    paused = true;
  }
  function rewind() {
    startTime = now();
    rate = 0;
    if (onUpdate) {
      onUpdate(rate);
    }
  }
  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }
  function set2(time) {
    interval = time;
  }
  function isPaused() {
    return paused;
  }
  return {
    start,
    rewind,
    pause,
    cancel,
    set: set2,
    isPaused
  };
}
function State(initialState) {
  var state = initialState;
  function set2(value) {
    state = value;
  }
  function is(states) {
    return includes(toArray(states), state);
  }
  return {
    set: set2,
    is
  };
}
function Throttle(func, duration) {
  var interval = RequestInterval(0, func, null, 1);
  return function() {
    interval.isPaused() && interval.start();
  };
}
function Media(Splide2, Components2, options) {
  var state = Splide2.state;
  var breakpoints = options.breakpoints || {};
  var reducedMotion = options.reducedMotion || {};
  var binder = EventBinder();
  var queries = [];
  function setup() {
    var isMin = options.mediaQuery === "min";
    ownKeys(breakpoints).sort(function(n, m) {
      return isMin ? +n - +m : +m - +n;
    }).forEach(function(key) {
      register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
    });
    register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
    update();
  }
  function destroy(completely) {
    if (completely) {
      binder.destroy();
    }
  }
  function register(options2, query2) {
    var queryList = matchMedia(query2);
    binder.bind(queryList, "change", update);
    queries.push([options2, queryList]);
  }
  function update() {
    var destroyed = state.is(DESTROYED);
    var direction = options.direction;
    var merged = queries.reduce(function(merged2, entry) {
      return merge(merged2, entry[1].matches ? entry[0] : {});
    }, {});
    omit(options);
    set2(merged);
    if (options.destroy) {
      Splide2.destroy(options.destroy === "completely");
    } else if (destroyed) {
      destroy(true);
      Splide2.mount();
    } else {
      direction !== options.direction && Splide2.refresh();
    }
  }
  function reduce(enable) {
    if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
      enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
    }
  }
  function set2(opts, base, notify) {
    merge(options, opts);
    base && merge(Object.getPrototypeOf(options), opts);
    if (notify || !state.is(CREATED)) {
      Splide2.emit(EVENT_UPDATED, options);
    }
  }
  return {
    setup,
    destroy,
    reduce,
    set: set2
  };
}
var ARROW = "Arrow";
var ARROW_LEFT = ARROW + "Left";
var ARROW_RIGHT = ARROW + "Right";
var ARROW_UP = ARROW + "Up";
var ARROW_DOWN = ARROW + "Down";
var RTL = "rtl";
var TTB = "ttb";
var ORIENTATION_MAP = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [ARROW_UP, ARROW_RIGHT],
  ArrowRight: [ARROW_DOWN, ARROW_LEFT]
};
function Direction(Splide2, Components2, options) {
  function resolve(prop, axisOnly, direction) {
    direction = direction || options.direction;
    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
    return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
      var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
    });
  }
  function orient(value) {
    return value * (options.direction === RTL ? 1 : -1);
  }
  return {
    resolve,
    orient
  };
}
var ROLE = "role";
var TAB_INDEX = "tabindex";
var DISABLED = "disabled";
var ARIA_PREFIX = "aria-";
var ARIA_CONTROLS = ARIA_PREFIX + "controls";
var ARIA_CURRENT = ARIA_PREFIX + "current";
var ARIA_SELECTED = ARIA_PREFIX + "selected";
var ARIA_LABEL = ARIA_PREFIX + "label";
var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
var ARIA_LIVE = ARIA_PREFIX + "live";
var ARIA_BUSY = ARIA_PREFIX + "busy";
var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
var CLASS_PREFIX = PROJECT_CODE + "__";
var STATUS_CLASS_PREFIX = "is-";
var CLASS_ROOT = PROJECT_CODE;
var CLASS_TRACK = CLASS_PREFIX + "track";
var CLASS_LIST = CLASS_PREFIX + "list";
var CLASS_SLIDE = CLASS_PREFIX + "slide";
var CLASS_CLONE = CLASS_SLIDE + "--clone";
var CLASS_CONTAINER = CLASS_SLIDE + "__container";
var CLASS_ARROWS = CLASS_PREFIX + "arrows";
var CLASS_ARROW = CLASS_PREFIX + "arrow";
var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
var CLASS_PROGRESS = CLASS_PREFIX + "progress";
var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
var CLASS_SPINNER = CLASS_PREFIX + "spinner";
var CLASS_SR = CLASS_PREFIX + "sr";
var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
var CLASSES = {
  slide: CLASS_SLIDE,
  clone: CLASS_CLONE,
  arrows: CLASS_ARROWS,
  arrow: CLASS_ARROW,
  prev: CLASS_ARROW_PREV,
  next: CLASS_ARROW_NEXT,
  pagination: CLASS_PAGINATION,
  page: CLASS_PAGINATION_PAGE,
  spinner: CLASS_SPINNER
};
function closest(from, selector) {
  if (isFunction(from.closest)) {
    return from.closest(selector);
  }
  var elm = from;
  while (elm && elm.nodeType === 1) {
    if (matches(elm, selector)) {
      break;
    }
    elm = elm.parentElement;
  }
  return elm;
}
var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = "touchstart mousedown";
var POINTER_MOVE_EVENTS = "touchmove mousemove";
var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function Elements(Splide2, Components2, options) {
  var _EventInterface = EventInterface(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
  var root = Splide2.root;
  var i18n = options.i18n;
  var elements = {};
  var slides = [];
  var rootClasses = [];
  var trackClasses = [];
  var track;
  var list;
  var isUsingKey;
  function setup() {
    collect();
    init();
    update();
  }
  function mount() {
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, setup);
    on(EVENT_UPDATED, update);
    bind(document, POINTER_DOWN_EVENTS + " keydown", function(e) {
      isUsingKey = e.type === "keydown";
    }, {
      capture: true
    });
    bind(root, "focusin", function() {
      toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
    });
  }
  function destroy(completely) {
    var attrs = ALL_ATTRIBUTES.concat("style");
    empty(slides);
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    removeAttribute([track, list], attrs);
    removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
  }
  function update() {
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    rootClasses = getClasses(CLASS_ROOT);
    trackClasses = getClasses(CLASS_TRACK);
    addClass(root, rootClasses);
    addClass(track, trackClasses);
    setAttribute(root, ARIA_LABEL, options.label);
    setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
  }
  function collect() {
    track = find("." + CLASS_TRACK);
    list = child(track, "." + CLASS_LIST);
    assert(track && list, "A track/list element is missing.");
    push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
    forOwn({
      arrows: CLASS_ARROWS,
      pagination: CLASS_PAGINATION,
      prev: CLASS_ARROW_PREV,
      next: CLASS_ARROW_NEXT,
      bar: CLASS_PROGRESS_BAR,
      toggle: CLASS_TOGGLE
    }, function(className, key) {
      elements[key] = find("." + className);
    });
    assign(elements, {
      root,
      track,
      list,
      slides
    });
  }
  function init() {
    var id = root.id || uniqueId(PROJECT_CODE);
    var role = options.role;
    root.id = id;
    track.id = track.id || id + "-track";
    list.id = list.id || id + "-list";
    if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
      setAttribute(root, ROLE, role);
    }
    setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
    setAttribute(list, ROLE, "presentation");
  }
  function find(selector) {
    var elm = query(root, selector);
    return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
  }
  function getClasses(base) {
    return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
  }
  return assign(elements, {
    setup,
    mount,
    destroy
  });
}
var SLIDE = "slide";
var LOOP = "loop";
var FADE = "fade";
function Slide$1(Splide2, index, slideIndex, slide) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
  var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
  var resolve = Components.Direction.resolve;
  var styles = getAttribute(slide, "style");
  var label = getAttribute(slide, ARIA_LABEL);
  var isClone = slideIndex > -1;
  var container = child(slide, "." + CLASS_CONTAINER);
  var destroyed;
  function mount() {
    if (!isClone) {
      slide.id = root.id + "-slide" + pad(index + 1);
      setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
      setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
      setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
    }
    listen();
  }
  function listen() {
    bind(slide, "click", apply(emit, EVENT_CLICK, self));
    bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self));
    on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
    on(EVENT_NAVIGATION_MOUNTED, initNavigation);
    if (updateOnMove) {
      on(EVENT_MOVE, onMove);
    }
  }
  function destroy() {
    destroyed = true;
    event.destroy();
    removeClass(slide, STATUS_CLASSES);
    removeAttribute(slide, ALL_ATTRIBUTES);
    setAttribute(slide, "style", styles);
    setAttribute(slide, ARIA_LABEL, label || "");
  }
  function initNavigation() {
    var controls = Splide2.splides.map(function(target) {
      var Slide2 = target.splide.Components.Slides.getAt(index);
      return Slide2 ? Slide2.slide.id : "";
    }).join(" ");
    setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
    setAttribute(slide, ARIA_CONTROLS, controls);
    setAttribute(slide, ROLE, slideFocus ? "button" : "");
    slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
  }
  function onMove() {
    if (!destroyed) {
      update();
    }
  }
  function update() {
    if (!destroyed) {
      var curr = Splide2.index;
      updateActivity();
      updateVisibility();
      toggleClass(slide, CLASS_PREV, index === curr - 1);
      toggleClass(slide, CLASS_NEXT, index === curr + 1);
    }
  }
  function updateActivity() {
    var active = isActive();
    if (active !== hasClass(slide, CLASS_ACTIVE)) {
      toggleClass(slide, CLASS_ACTIVE, active);
      setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
    }
  }
  function updateVisibility() {
    var visible = isVisible();
    var hidden = !visible && (!isActive() || isClone);
    if (!Splide2.state.is([MOVING, SCROLLING])) {
      setAttribute(slide, ARIA_HIDDEN, hidden || "");
    }
    setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
    if (slideFocus) {
      setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
    }
    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
      toggleClass(slide, CLASS_VISIBLE, visible);
      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
    }
    if (!visible && document.activeElement === slide) {
      var Slide2 = Components.Slides.getAt(Splide2.index);
      Slide2 && focus(Slide2.slide);
    }
  }
  function style$1(prop, value, useContainer) {
    style(useContainer && container || slide, prop, value);
  }
  function isActive() {
    var curr = Splide2.index;
    return curr === index || options.cloneStatus && curr === slideIndex;
  }
  function isVisible() {
    if (Splide2.is(FADE)) {
      return isActive();
    }
    var trackRect = rect(Components.Elements.track);
    var slideRect = rect(slide);
    var left = resolve("left", true);
    var right = resolve("right", true);
    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
  }
  function isWithin(from, distance) {
    var diff = abs(from - index);
    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
      diff = min(diff, Splide2.length - diff);
    }
    return diff <= distance;
  }
  var self = {
    index,
    slideIndex,
    slide,
    container,
    isClone,
    mount,
    destroy,
    update,
    style: style$1,
    isWithin
  };
  return self;
}
function Slides(Splide2, Components2, options) {
  var _EventInterface2 = EventInterface(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
  var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
  var Slides2 = [];
  function mount() {
    init();
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, init);
  }
  function init() {
    slides.forEach(function(slide, index) {
      register(slide, index, -1);
    });
  }
  function destroy() {
    forEach$1(function(Slide2) {
      Slide2.destroy();
    });
    empty(Slides2);
  }
  function update() {
    forEach$1(function(Slide2) {
      Slide2.update();
    });
  }
  function register(slide, index, slideIndex) {
    var object = Slide$1(Splide2, index, slideIndex, slide);
    object.mount();
    Slides2.push(object);
    Slides2.sort(function(Slide1, Slide2) {
      return Slide1.index - Slide2.index;
    });
  }
  function get3(excludeClones) {
    return excludeClones ? filter(function(Slide2) {
      return !Slide2.isClone;
    }) : Slides2;
  }
  function getIn(page) {
    var Controller2 = Components2.Controller;
    var index = Controller2.toIndex(page);
    var max2 = Controller2.hasFocus() ? 1 : options.perPage;
    return filter(function(Slide2) {
      return between(Slide2.index, index, index + max2 - 1);
    });
  }
  function getAt(index) {
    return filter(index)[0];
  }
  function add(items, index) {
    forEach(items, function(slide) {
      if (isString(slide)) {
        slide = parseHtml(slide);
      }
      if (isHTMLElement(slide)) {
        var ref = slides[index];
        ref ? before(slide, ref) : append(list, slide);
        addClass(slide, options.classes.slide);
        observeImages(slide, apply(emit, EVENT_RESIZE));
      }
    });
    emit(EVENT_REFRESH);
  }
  function remove$1(matcher) {
    remove(filter(matcher).map(function(Slide2) {
      return Slide2.slide;
    }));
    emit(EVENT_REFRESH);
  }
  function forEach$1(iteratee, excludeClones) {
    get3(excludeClones).forEach(iteratee);
  }
  function filter(matcher) {
    return Slides2.filter(isFunction(matcher) ? matcher : function(Slide2) {
      return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
    });
  }
  function style2(prop, value, useContainer) {
    forEach$1(function(Slide2) {
      Slide2.style(prop, value, useContainer);
    });
  }
  function observeImages(elm, callback) {
    var images = queryAll(elm, "img");
    var length = images.length;
    if (length) {
      images.forEach(function(img) {
        bind(img, "load error", function() {
          if (!--length) {
            callback();
          }
        });
      });
    } else {
      callback();
    }
  }
  function getLength(excludeClones) {
    return excludeClones ? slides.length : Slides2.length;
  }
  function isEnough() {
    return Slides2.length > options.perPage;
  }
  return {
    mount,
    destroy,
    update,
    register,
    get: get3,
    getIn,
    getAt,
    add,
    remove: remove$1,
    forEach: forEach$1,
    filter,
    style: style2,
    getLength,
    isEnough
  };
}
function Layout(Splide2, Components2, options) {
  var _EventInterface3 = EventInterface(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
  var Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
  var getAt = Slides2.getAt, styleSlides = Slides2.style;
  var vertical;
  var rootRect;
  var overflow;
  function mount() {
    init();
    bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
    on([EVENT_UPDATED, EVENT_REFRESH], init);
    on(EVENT_RESIZE, resize);
  }
  function init() {
    vertical = options.direction === TTB;
    style(root, "maxWidth", unit(options.width));
    style(track, resolve("paddingLeft"), cssPadding(false));
    style(track, resolve("paddingRight"), cssPadding(true));
    resize(true);
  }
  function resize(force) {
    var newRect = rect(root);
    if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
      style(track, "height", cssTrackHeight());
      styleSlides(resolve("marginRight"), unit(options.gap));
      styleSlides("width", cssSlideWidth());
      styleSlides("height", cssSlideHeight(), true);
      rootRect = newRect;
      emit(EVENT_RESIZED);
      if (overflow !== (overflow = isOverflow())) {
        toggleClass(root, CLASS_OVERFLOW, overflow);
        emit(EVENT_OVERFLOW, overflow);
      }
    }
  }
  function cssPadding(right) {
    var padding = options.padding;
    var prop = resolve(right ? "right" : "left");
    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
  }
  function cssTrackHeight() {
    var height = "";
    if (vertical) {
      height = cssHeight();
      assert(height, "height or heightRatio is missing.");
      height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
    }
    return height;
  }
  function cssHeight() {
    return unit(options.height || rect(list).width * options.heightRatio);
  }
  function cssSlideWidth() {
    return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
  }
  function cssSlideHeight() {
    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
  }
  function cssSlideSize() {
    var gap = unit(options.gap);
    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
  }
  function listSize() {
    return rect(list)[resolve("width")];
  }
  function slideSize(index, withoutGap) {
    var Slide2 = getAt(index || 0);
    return Slide2 ? rect(Slide2.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
  }
  function totalSize(index, withoutGap) {
    var Slide2 = getAt(index);
    if (Slide2) {
      var right = rect(Slide2.slide)[resolve("right")];
      var left = rect(list)[resolve("left")];
      return abs(right - left) + (withoutGap ? 0 : getGap());
    }
    return 0;
  }
  function sliderSize(withoutGap) {
    return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
  }
  function getGap() {
    var Slide2 = getAt(0);
    return Slide2 && parseFloat(style(Slide2.slide, resolve("marginRight"))) || 0;
  }
  function getPadding(right) {
    return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
  }
  function isOverflow() {
    return Splide2.is(FADE) || sliderSize(true) > listSize();
  }
  return {
    mount,
    resize,
    listSize,
    slideSize,
    sliderSize,
    totalSize,
    getPadding,
    isOverflow
  };
}
var MULTIPLIER = 2;
function Clones(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on;
  var Elements2 = Components2.Elements, Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var clones = [];
  var cloneCount;
  function mount() {
    on(EVENT_REFRESH, remount);
    on([EVENT_UPDATED, EVENT_RESIZE], observe);
    if (cloneCount = computeCloneCount()) {
      generate(cloneCount);
      Components2.Layout.resize(true);
    }
  }
  function remount() {
    destroy();
    mount();
  }
  function destroy() {
    remove(clones);
    empty(clones);
    event.destroy();
  }
  function observe() {
    var count = computeCloneCount();
    if (cloneCount !== count) {
      if (cloneCount < count || !count) {
        event.emit(EVENT_REFRESH);
      }
    }
  }
  function generate(count) {
    var slides = Slides2.get().slice();
    var length = slides.length;
    if (length) {
      while (slides.length < count) {
        push(slides, slides);
      }
      push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide2, index) {
        var isHead = index < count;
        var clone = cloneDeep(Slide2.slide, index);
        isHead ? before(clone, slides[0].slide) : append(Elements2.list, clone);
        push(clones, clone);
        Slides2.register(clone, index - count + (isHead ? 0 : length), Slide2.index);
      });
    }
  }
  function cloneDeep(elm, index) {
    var clone = elm.cloneNode(true);
    addClass(clone, options.classes.clone);
    clone.id = Splide2.root.id + "-clone" + pad(index + 1);
    return clone;
  }
  function computeCloneCount() {
    var clones2 = options.clones;
    if (!Splide2.is(LOOP)) {
      clones2 = 0;
    } else if (isUndefined(clones2)) {
      var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
      var fixedCount = fixedSize && ceil(rect(Elements2.track)[resolve("width")] / fixedSize);
      clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
    }
    return clones2;
  }
  return {
    mount,
    destroy
  };
}
function Move(Splide2, Components2, options) {
  var _EventInterface4 = EventInterface(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
  var set2 = Splide2.state.set;
  var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
  var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
  var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
  var Transition;
  function mount() {
    Transition = Components2.Transition;
    on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
  }
  function reposition() {
    if (!Components2.Controller.isBusy()) {
      Components2.Scroll.cancel();
      jump(Splide2.index);
      Components2.Slides.update();
    }
  }
  function move(dest, index, prev, callback) {
    if (dest !== index && canShift(dest > prev)) {
      cancel();
      translate(shift(getPosition(), dest > prev), true);
    }
    set2(MOVING);
    emit(EVENT_MOVE, index, prev, dest);
    Transition.start(index, function() {
      set2(IDLE);
      emit(EVENT_MOVED, index, prev, dest);
      callback && callback();
    });
  }
  function jump(index) {
    translate(toPosition(index, true));
  }
  function translate(position, preventLoop) {
    if (!Splide2.is(FADE)) {
      var destination = preventLoop ? position : loop(position);
      style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
      position !== destination && emit(EVENT_SHIFTED);
    }
  }
  function loop(position) {
    if (Splide2.is(LOOP)) {
      var index = toIndex(position);
      var exceededMax = index > Components2.Controller.getEnd();
      var exceededMin = index < 0;
      if (exceededMin || exceededMax) {
        position = shift(position, exceededMax);
      }
    }
    return position;
  }
  function shift(position, backwards) {
    var excess = position - getLimit(backwards);
    var size = sliderSize();
    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
    return position;
  }
  function cancel() {
    translate(getPosition(), true);
    Transition.cancel();
  }
  function toIndex(position) {
    var Slides2 = Components2.Slides.get();
    var index = 0;
    var minDistance = Infinity;
    for (var i = 0; i < Slides2.length; i++) {
      var slideIndex = Slides2[i].index;
      var distance = abs(toPosition(slideIndex, true) - position);
      if (distance <= minDistance) {
        minDistance = distance;
        index = slideIndex;
      } else {
        break;
      }
    }
    return index;
  }
  function toPosition(index, trimming) {
    var position = orient(totalSize(index - 1) - offset(index));
    return trimming ? trim(position) : position;
  }
  function getPosition() {
    var left = resolve("left");
    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
  }
  function trim(position) {
    if (options.trimSpace && Splide2.is(SLIDE)) {
      position = clamp(position, 0, orient(sliderSize(true) - listSize()));
    }
    return position;
  }
  function offset(index) {
    var focus2 = options.focus;
    return focus2 === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus2 * slideSize(index) || 0;
  }
  function getLimit(max2) {
    return toPosition(max2 ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
  }
  function canShift(backwards) {
    var shifted = orient(shift(getPosition(), backwards));
    return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
  }
  function exceededLimit(max2, position) {
    position = isUndefined(position) ? getPosition() : position;
    var exceededMin = max2 !== true && orient(position) < orient(getLimit(false));
    var exceededMax = max2 !== false && orient(position) > orient(getLimit(true));
    return exceededMin || exceededMax;
  }
  return {
    mount,
    move,
    jump,
    translate,
    shift,
    cancel,
    toIndex,
    toPosition,
    getPosition,
    getLimit,
    exceededLimit,
    reposition
  };
}
function Controller(Splide2, Components2, options) {
  var _EventInterface5 = EventInterface(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, toPosition = Move2.toPosition;
  var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
  var omitEnd = options.omitEnd;
  var isLoop = Splide2.is(LOOP);
  var isSlide = Splide2.is(SLIDE);
  var getNext = apply(getAdjacent, false);
  var getPrev = apply(getAdjacent, true);
  var currIndex = options.start || 0;
  var endIndex;
  var prevIndex = currIndex;
  var slideCount;
  var perMove;
  var perPage;
  function mount() {
    init();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
    on(EVENT_RESIZED, onResized);
  }
  function init() {
    slideCount = getLength(true);
    perMove = options.perMove;
    perPage = options.perPage;
    endIndex = getEnd();
    var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
    if (index !== currIndex) {
      currIndex = index;
      Move2.reposition();
    }
  }
  function onResized() {
    if (endIndex !== getEnd()) {
      emit(EVENT_END_INDEX_CHANGED);
    }
  }
  function go(control, allowSameIndex, callback) {
    if (!isBusy()) {
      var dest = parse(control);
      var index = loop(dest);
      if (index > -1 && (allowSameIndex || index !== currIndex)) {
        setIndex(index);
        Move2.move(dest, index, prevIndex, callback);
      }
    }
  }
  function scroll(destination, duration, snap, callback) {
    Components2.Scroll.scroll(destination, duration, snap, function() {
      var index = loop(Move2.toIndex(getPosition()));
      setIndex(omitEnd ? min(index, endIndex) : index);
      callback && callback();
    });
  }
  function parse(control) {
    var index = currIndex;
    if (isString(control)) {
      var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
      if (indicator === "+" || indicator === "-") {
        index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
      } else if (indicator === ">") {
        index = number ? toIndex(+number) : getNext(true);
      } else if (indicator === "<") {
        index = getPrev(true);
      }
    } else {
      index = isLoop ? control : clamp(control, 0, endIndex);
    }
    return index;
  }
  function getAdjacent(prev, destination) {
    var number = perMove || (hasFocus() ? 1 : perPage);
    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
    if (dest === -1 && isSlide) {
      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
        return prev ? 0 : endIndex;
      }
    }
    return destination ? dest : loop(dest);
  }
  function computeDestIndex(dest, from, snapPage) {
    if (isEnough() || hasFocus()) {
      var index = computeMovableDestIndex(dest);
      if (index !== dest) {
        from = dest;
        dest = index;
        snapPage = false;
      }
      if (dest < 0 || dest > endIndex) {
        if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
          dest = toIndex(toPage(dest));
        } else {
          if (isLoop) {
            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
          } else if (options.rewind) {
            dest = dest < 0 ? endIndex : 0;
          } else {
            dest = -1;
          }
        }
      } else {
        if (snapPage && dest !== from) {
          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        }
      }
    } else {
      dest = -1;
    }
    return dest;
  }
  function computeMovableDestIndex(dest) {
    if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
      var position = getPosition();
      while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
        dest < currIndex ? --dest : ++dest;
      }
    }
    return dest;
  }
  function loop(index) {
    return isLoop ? (index + slideCount) % slideCount || 0 : index;
  }
  function getEnd() {
    var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
    while (omitEnd && end-- > 0) {
      if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
        end++;
        break;
      }
    }
    return clamp(end, 0, slideCount - 1);
  }
  function toIndex(page) {
    return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
  }
  function toPage(index) {
    return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
  }
  function toDest(destination) {
    var closest2 = Move2.toIndex(destination);
    return isSlide ? clamp(closest2, 0, endIndex) : closest2;
  }
  function setIndex(index) {
    if (index !== currIndex) {
      prevIndex = currIndex;
      currIndex = index;
    }
  }
  function getIndex(prev) {
    return prev ? prevIndex : currIndex;
  }
  function hasFocus() {
    return !isUndefined(options.focus) || options.isNavigation;
  }
  function isBusy() {
    return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
  }
  return {
    mount,
    go,
    scroll,
    getNext,
    getPrev,
    getAdjacent,
    getEnd,
    setIndex,
    getIndex,
    toIndex,
    toPage,
    toDest,
    hasFocus,
    isBusy
  };
}
var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var SIZE = 40;
function Arrows(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, bind = event.bind, emit = event.emit;
  var classes = options.classes, i18n = options.i18n;
  var Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var placeholder = Elements2.arrows, track = Elements2.track;
  var wrapper = placeholder;
  var prev = Elements2.prev;
  var next = Elements2.next;
  var created;
  var wrapperClasses;
  var arrows = {};
  function mount() {
    init();
    on(EVENT_UPDATED, remount);
  }
  function remount() {
    destroy();
    mount();
  }
  function init() {
    var enabled = options.arrows;
    if (enabled && !(prev && next)) {
      createArrows();
    }
    if (prev && next) {
      assign(arrows, {
        prev,
        next
      });
      display(wrapper, enabled ? "" : "none");
      addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
      if (enabled) {
        listen();
        update();
        setAttribute([prev, next], ARIA_CONTROLS, track.id);
        emit(EVENT_ARROWS_MOUNTED, prev, next);
      }
    }
  }
  function destroy() {
    event.destroy();
    removeClass(wrapper, wrapperClasses);
    if (created) {
      remove(placeholder ? [prev, next] : wrapper);
      prev = next = null;
    } else {
      removeAttribute([prev, next], ALL_ATTRIBUTES);
    }
  }
  function listen() {
    on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
    bind(next, "click", apply(go, ">"));
    bind(prev, "click", apply(go, "<"));
  }
  function go(control) {
    Controller2.go(control, true);
  }
  function createArrows() {
    wrapper = placeholder || create("div", classes.arrows);
    prev = createArrow(true);
    next = createArrow(false);
    created = true;
    append(wrapper, [prev, next]);
    !placeholder && before(wrapper, track);
  }
  function createArrow(prev2) {
    var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + XML_NAME_SPACE + '" viewBox="0 0 ' + SIZE + " " + SIZE + '" width="' + SIZE + '" height="' + SIZE + '" focusable="false"><path d="' + (options.arrowPath || PATH) + '" />';
    return parseHtml(arrow);
  }
  function update() {
    if (prev && next) {
      var index = Splide2.index;
      var prevIndex = Controller2.getPrev();
      var nextIndex = Controller2.getNext();
      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
      prev.disabled = prevIndex < 0;
      next.disabled = nextIndex < 0;
      setAttribute(prev, ARIA_LABEL, prevLabel);
      setAttribute(next, ARIA_LABEL, nextLabel);
      emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
    }
  }
  return {
    arrows,
    mount,
    destroy,
    update
  };
}
var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
function Autoplay(Splide2, Components2, options) {
  var _EventInterface6 = EventInterface(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
  var isPaused = interval.isPaused;
  var Elements2 = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
  var autoplay = options.autoplay;
  var hovered;
  var focused;
  var stopped = autoplay === "pause";
  function mount() {
    if (autoplay) {
      listen();
      toggle && setAttribute(toggle, ARIA_CONTROLS, Elements2.track.id);
      stopped || play();
      update();
    }
  }
  function listen() {
    if (options.pauseOnHover) {
      bind(root, "mouseenter mouseleave", function(e) {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }
    if (options.pauseOnFocus) {
      bind(root, "focusin focusout", function(e) {
        focused = e.type === "focusin";
        autoToggle();
      });
    }
    if (toggle) {
      bind(toggle, "click", function() {
        stopped ? play() : pause(true);
      });
    }
    on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
    on(EVENT_MOVE, onMove);
  }
  function play() {
    if (isPaused() && Components2.Slides.isEnough()) {
      interval.start(!options.resetProgress);
      focused = hovered = stopped = false;
      update();
      emit(EVENT_AUTOPLAY_PLAY);
    }
  }
  function pause(stop) {
    if (stop === void 0) {
      stop = true;
    }
    stopped = !!stop;
    update();
    if (!isPaused()) {
      interval.pause();
      emit(EVENT_AUTOPLAY_PAUSE);
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused ? pause(false) : play();
    }
  }
  function update() {
    if (toggle) {
      toggleClass(toggle, CLASS_ACTIVE, !stopped);
      setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
    }
  }
  function onAnimationFrame(rate) {
    var bar = Elements2.bar;
    bar && style(bar, "width", rate * 100 + "%");
    emit(EVENT_AUTOPLAY_PLAYING, rate);
  }
  function onMove(index) {
    var Slide2 = Components2.Slides.getAt(index);
    interval.set(Slide2 && +getAttribute(Slide2.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
  }
  return {
    mount,
    destroy: interval.cancel,
    play,
    pause,
    isPaused
  };
}
function Cover(Splide2, Components2, options) {
  var _EventInterface7 = EventInterface(Splide2), on = _EventInterface7.on;
  function mount() {
    if (options.cover) {
      on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
      on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
    }
  }
  function cover(cover2) {
    Components2.Slides.forEach(function(Slide2) {
      var img = child(Slide2.container || Slide2.slide, "img");
      if (img && img.src) {
        toggle(cover2, img, Slide2);
      }
    });
  }
  function toggle(cover2, img, Slide2) {
    Slide2.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
    display(img, cover2 ? "none" : "");
  }
  return {
    mount,
    destroy: apply(cover, false)
  };
}
var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = 0.6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;
function Scroll(Splide2, Components2, options) {
  var _EventInterface8 = EventInterface(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
  var set2 = Splide2.state.set;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, exceededLimit = Move2.exceededLimit, translate = Move2.translate;
  var isSlide = Splide2.is(SLIDE);
  var interval;
  var callback;
  var friction = 1;
  function mount() {
    on(EVENT_MOVE, clear);
    on([EVENT_UPDATED, EVENT_REFRESH], cancel);
  }
  function scroll(destination, duration, snap, onScrolled, noConstrain) {
    var from = getPosition();
    clear();
    if (snap && (!isSlide || !exceededLimit())) {
      var size = Components2.Layout.sliderSize();
      var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
      destination = Move2.toPosition(Components2.Controller.toDest(destination % size)) + offset;
    }
    var noDistance = approximatelyEqual(from, destination, 1);
    friction = 1;
    duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
    callback = onScrolled;
    interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
    set2(SCROLLING);
    emit(EVENT_SCROLL);
    interval.start();
  }
  function onEnd() {
    set2(IDLE);
    callback && callback();
    emit(EVENT_SCROLLED);
  }
  function update(from, to, noConstrain, rate) {
    var position = getPosition();
    var target = from + (to - from) * easing(rate);
    var diff = (target - position) * friction;
    translate(position + diff);
    if (isSlide && !noConstrain && exceededLimit()) {
      friction *= FRICTION_FACTOR;
      if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
        scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
      }
    }
  }
  function clear() {
    if (interval) {
      interval.cancel();
    }
  }
  function cancel() {
    if (interval && !interval.isPaused()) {
      clear();
      onEnd();
    }
  }
  function easing(t) {
    var easingFunc = options.easingFunc;
    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
  }
  return {
    mount,
    destroy: clear,
    scroll,
    cancel
  };
}
var SCROLL_LISTENER_OPTIONS = {
  passive: false,
  capture: true
};
function Drag(Splide2, Components2, options) {
  var _EventInterface9 = EventInterface(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
  var state = Splide2.state;
  var Move2 = Components2.Move, Scroll2 = Components2.Scroll, Controller2 = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
  var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
  var getPosition = Move2.getPosition, exceededLimit = Move2.exceededLimit;
  var basePosition;
  var baseEvent;
  var prevBaseEvent;
  var isFree;
  var dragging;
  var exceeded = false;
  var clickPrevented;
  var disabled;
  var target;
  function mount() {
    bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
    bind(track, "click", onClick, {
      capture: true
    });
    bind(track, "dragstart", prevent);
    on([EVENT_MOUNTED, EVENT_UPDATED], init);
  }
  function init() {
    var drag = options.drag;
    disable(!drag);
    isFree = drag === "free";
  }
  function onPointerDown(e) {
    clickPrevented = false;
    if (!disabled) {
      var isTouch = isTouchEvent(e);
      if (isDraggable(e.target) && (isTouch || !e.button)) {
        if (!Controller2.isBusy()) {
          target = isTouch ? track : window;
          dragging = state.is([MOVING, SCROLLING]);
          prevBaseEvent = null;
          bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
          bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
          Move2.cancel();
          Scroll2.cancel();
          save(e);
        } else {
          prevent(e, true);
        }
      }
    }
  }
  function onPointerMove(e) {
    if (!state.is(DRAGGING)) {
      state.set(DRAGGING);
      emit(EVENT_DRAG);
    }
    if (e.cancelable) {
      if (dragging) {
        Move2.translate(basePosition + constrain(diffCoord(e)));
        var expired = diffTime(e) > LOG_INTERVAL;
        var hasExceeded = exceeded !== (exceeded = exceededLimit());
        if (expired || hasExceeded) {
          save(e);
        }
        clickPrevented = true;
        emit(EVENT_DRAGGING);
        prevent(e);
      } else if (isSliderDirection(e)) {
        dragging = shouldStart(e);
        prevent(e);
      }
    }
  }
  function onPointerUp(e) {
    if (state.is(DRAGGING)) {
      state.set(IDLE);
      emit(EVENT_DRAGGED);
    }
    if (dragging) {
      move(e);
      prevent(e);
    }
    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
    unbind(target, POINTER_UP_EVENTS, onPointerUp);
    dragging = false;
  }
  function onClick(e) {
    if (!disabled && clickPrevented) {
      prevent(e, true);
    }
  }
  function save(e) {
    prevBaseEvent = baseEvent;
    baseEvent = e;
    basePosition = getPosition();
  }
  function move(e) {
    var velocity = computeVelocity(e);
    var destination = computeDestination(velocity);
    var rewind = options.rewind && options.rewindByDrag;
    reduce(false);
    if (isFree) {
      Controller2.scroll(destination, 0, options.snap);
    } else if (Splide2.is(FADE)) {
      Controller2.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
    } else if (Splide2.is(SLIDE) && exceeded && rewind) {
      Controller2.go(exceededLimit(true) ? ">" : "<");
    } else {
      Controller2.go(Controller2.toDest(destination), true);
    }
    reduce(true);
  }
  function shouldStart(e) {
    var thresholds = options.dragMinThreshold;
    var isObj = isObject(thresholds);
    var mouse = isObj && thresholds.mouse || 0;
    var touch = (isObj ? thresholds.touch : +thresholds) || 10;
    return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
  }
  function isSliderDirection(e) {
    return abs(diffCoord(e)) > abs(diffCoord(e, true));
  }
  function computeVelocity(e) {
    if (Splide2.is(LOOP) || !exceeded) {
      var time = diffTime(e);
      if (time && time < LOG_INTERVAL) {
        return diffCoord(e) / time;
      }
    }
    return 0;
  }
  function computeDestination(velocity) {
    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
  }
  function diffCoord(e, orthogonal) {
    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
  }
  function diffTime(e) {
    return timeOf(e) - timeOf(getBaseEvent(e));
  }
  function getBaseEvent(e) {
    return baseEvent === e && prevBaseEvent || baseEvent;
  }
  function coordOf(e, orthogonal) {
    return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
  }
  function constrain(diff) {
    return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
  }
  function isDraggable(target2) {
    var noDrag = options.noDrag;
    return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
  }
  function isTouchEvent(e) {
    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
  }
  function isDragging() {
    return dragging;
  }
  function disable(value) {
    disabled = value;
  }
  return {
    mount,
    disable,
    isDragging
  };
}
var NORMALIZATION_MAP = {
  Spacebar: " ",
  Right: ARROW_RIGHT,
  Left: ARROW_LEFT,
  Up: ARROW_UP,
  Down: ARROW_DOWN
};
function normalizeKey(key) {
  key = isString(key) ? key : key.key;
  return NORMALIZATION_MAP[key] || key;
}
var KEYBOARD_EVENT = "keydown";
function Keyboard(Splide2, Components2, options) {
  var _EventInterface10 = EventInterface(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
  var root = Splide2.root;
  var resolve = Components2.Direction.resolve;
  var target;
  var disabled;
  function mount() {
    init();
    on(EVENT_UPDATED, destroy);
    on(EVENT_UPDATED, init);
    on(EVENT_MOVE, onMove);
  }
  function init() {
    var keyboard = options.keyboard;
    if (keyboard) {
      target = keyboard === "global" ? window : root;
      bind(target, KEYBOARD_EVENT, onKeydown);
    }
  }
  function destroy() {
    unbind(target, KEYBOARD_EVENT);
  }
  function disable(value) {
    disabled = value;
  }
  function onMove() {
    var _disabled = disabled;
    disabled = true;
    nextTick(function() {
      disabled = _disabled;
    });
  }
  function onKeydown(e) {
    if (!disabled) {
      var key = normalizeKey(e);
      if (key === resolve(ARROW_LEFT)) {
        Splide2.go("<");
      } else if (key === resolve(ARROW_RIGHT)) {
        Splide2.go(">");
      }
    }
  }
  return {
    mount,
    destroy,
    disable
  };
}
var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
function LazyLoad(Splide2, Components2, options) {
  var _EventInterface11 = EventInterface(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
  var isSequential = options.lazyLoad === "sequential";
  var events = [EVENT_MOVED, EVENT_SCROLLED];
  var entries = [];
  function mount() {
    if (options.lazyLoad) {
      init();
      on(EVENT_REFRESH, init);
    }
  }
  function init() {
    empty(entries);
    register();
    if (isSequential) {
      loadNext();
    } else {
      off(events);
      on(events, check);
      check();
    }
  }
  function register() {
    Components2.Slides.forEach(function(Slide2) {
      queryAll(Slide2.slide, IMAGE_SELECTOR).forEach(function(img) {
        var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
        var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
        if (src !== img.src || srcset !== img.srcset) {
          var className = options.classes.spinner;
          var parent = img.parentElement;
          var spinner = child(parent, "." + className) || create("span", className, parent);
          entries.push([img, Slide2, spinner]);
          img.src || display(img, "none");
        }
      });
    });
  }
  function check() {
    entries = entries.filter(function(data) {
      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
      return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
    });
    entries.length || off(events);
  }
  function load(data) {
    var img = data[0];
    addClass(data[1].slide, CLASS_LOADING);
    bind(img, "load error", apply(onLoad, data));
    setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
    setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
    removeAttribute(img, SRC_DATA_ATTRIBUTE);
    removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
  }
  function onLoad(data, e) {
    var img = data[0], Slide2 = data[1];
    removeClass(Slide2.slide, CLASS_LOADING);
    if (e.type !== "error") {
      remove(data[2]);
      display(img, "");
      emit(EVENT_LAZYLOAD_LOADED, img, Slide2);
      emit(EVENT_RESIZE);
    }
    isSequential && loadNext();
  }
  function loadNext() {
    entries.length && load(entries.shift());
  }
  return {
    mount,
    destroy: apply(empty, entries),
    check
  };
}
function Pagination(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Slides2 = Components2.Slides, Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var hasFocus = Controller2.hasFocus, getIndex = Controller2.getIndex, go = Controller2.go;
  var resolve = Components2.Direction.resolve;
  var placeholder = Elements2.pagination;
  var items = [];
  var list;
  var paginationClasses;
  function mount() {
    destroy();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
    var enabled = options.pagination;
    placeholder && display(placeholder, enabled ? "" : "none");
    if (enabled) {
      on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
      createPagination();
      update();
      emit(EVENT_PAGINATION_MOUNTED, {
        list,
        items
      }, getAt(Splide2.index));
    }
  }
  function destroy() {
    if (list) {
      remove(placeholder ? slice(list.children) : list);
      removeClass(list, paginationClasses);
      empty(items);
      list = null;
    }
    event.destroy();
  }
  function createPagination() {
    var length = Splide2.length;
    var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
    var max2 = hasFocus() ? Controller2.getEnd() + 1 : ceil(length / perPage);
    list = placeholder || create("ul", classes.pagination, Elements2.track.parentElement);
    addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
    setAttribute(list, ROLE, "tablist");
    setAttribute(list, ARIA_LABEL, i18n.select);
    setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
    for (var i = 0; i < max2; i++) {
      var li = create("li", null, list);
      var button = create("button", {
        class: classes.page,
        type: "button"
      }, li);
      var controls = Slides2.getIn(i).map(function(Slide2) {
        return Slide2.slide.id;
      });
      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
      bind(button, "click", apply(onClick, i));
      if (options.paginationKeyboard) {
        bind(button, "keydown", apply(onKeydown, i));
      }
      setAttribute(li, ROLE, "presentation");
      setAttribute(button, ROLE, "tab");
      setAttribute(button, ARIA_CONTROLS, controls.join(" "));
      setAttribute(button, ARIA_LABEL, format(text, i + 1));
      setAttribute(button, TAB_INDEX, -1);
      items.push({
        li,
        button,
        page: i
      });
    }
  }
  function onClick(page) {
    go(">" + page, true);
  }
  function onKeydown(page, e) {
    var length = items.length;
    var key = normalizeKey(e);
    var dir = getDirection();
    var nextPage = -1;
    if (key === resolve(ARROW_RIGHT, false, dir)) {
      nextPage = ++page % length;
    } else if (key === resolve(ARROW_LEFT, false, dir)) {
      nextPage = (--page + length) % length;
    } else if (key === "Home") {
      nextPage = 0;
    } else if (key === "End") {
      nextPage = length - 1;
    }
    var item = items[nextPage];
    if (item) {
      focus(item.button);
      go(">" + nextPage);
      prevent(e, true);
    }
  }
  function getDirection() {
    return options.paginationDirection || options.direction;
  }
  function getAt(index) {
    return items[Controller2.toPage(index)];
  }
  function update() {
    var prev = getAt(getIndex(true));
    var curr = getAt(getIndex());
    if (prev) {
      var button = prev.button;
      removeClass(button, CLASS_ACTIVE);
      removeAttribute(button, ARIA_SELECTED);
      setAttribute(button, TAB_INDEX, -1);
    }
    if (curr) {
      var _button = curr.button;
      addClass(_button, CLASS_ACTIVE);
      setAttribute(_button, ARIA_SELECTED, true);
      setAttribute(_button, TAB_INDEX, "");
    }
    emit(EVENT_PAGINATION_UPDATED, {
      list,
      items
    }, prev, curr);
  }
  return {
    items,
    mount,
    destroy,
    getAt,
    update
  };
}
var TRIGGER_KEYS = [" ", "Enter"];
function Sync(Splide2, Components2, options) {
  var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
  var events = [];
  function mount() {
    Splide2.splides.forEach(function(target) {
      if (!target.isParent) {
        sync(Splide2, target.splide);
        sync(target.splide, Splide2);
      }
    });
    if (isNavigation) {
      navigate();
    }
  }
  function destroy() {
    events.forEach(function(event) {
      event.destroy();
    });
    empty(events);
  }
  function remount() {
    destroy();
    mount();
  }
  function sync(splide, target) {
    var event = EventInterface(splide);
    event.on(EVENT_MOVE, function(index, prev, dest) {
      target.go(target.is(LOOP) ? dest : index);
    });
    events.push(event);
  }
  function navigate() {
    var event = EventInterface(Splide2);
    var on = event.on;
    on(EVENT_CLICK, onClick);
    on(EVENT_SLIDE_KEYDOWN, onKeydown);
    on([EVENT_MOUNTED, EVENT_UPDATED], update);
    events.push(event);
    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
  }
  function update() {
    setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
  }
  function onClick(Slide2) {
    Splide2.go(Slide2.index);
  }
  function onKeydown(Slide2, e) {
    if (includes(TRIGGER_KEYS, normalizeKey(e))) {
      onClick(Slide2);
      prevent(e);
    }
  }
  return {
    setup: apply(Components2.Media.set, {
      slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
    }, true),
    mount,
    destroy,
    remount
  };
}
function Wheel(Splide2, Components2, options) {
  var _EventInterface12 = EventInterface(Splide2), bind = _EventInterface12.bind;
  var lastTime = 0;
  function mount() {
    if (options.wheel) {
      bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
    }
  }
  function onWheel(e) {
    if (e.cancelable) {
      var deltaY = e.deltaY;
      var backwards = deltaY < 0;
      var timeStamp = timeOf(e);
      var _min = options.wheelMinThreshold || 0;
      var sleep = options.wheelSleep || 0;
      if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
        Splide2.go(backwards ? "<" : ">");
        lastTime = timeStamp;
      }
      shouldPrevent(backwards) && prevent(e);
    }
  }
  function shouldPrevent(backwards) {
    return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
  }
  return {
    mount
  };
}
var SR_REMOVAL_DELAY = 90;
function Live(Splide2, Components2, options) {
  var _EventInterface13 = EventInterface(Splide2), on = _EventInterface13.on;
  var track = Components2.Elements.track;
  var enabled = options.live && !options.isNavigation;
  var sr = create("span", CLASS_SR);
  var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
  function mount() {
    if (enabled) {
      disable(!Components2.Autoplay.isPaused());
      setAttribute(track, ARIA_ATOMIC, true);
      sr.textContent = "…";
      on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
      on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
      on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
    }
  }
  function toggle(active) {
    setAttribute(track, ARIA_BUSY, active);
    if (active) {
      append(track, sr);
      interval.start();
    } else {
      remove(sr);
      interval.cancel();
    }
  }
  function destroy() {
    removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
    remove(sr);
  }
  function disable(disabled) {
    if (enabled) {
      setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
    }
  }
  return {
    mount,
    disable,
    destroy
  };
}
var ComponentConstructors = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media,
  Direction,
  Elements,
  Slides,
  Layout,
  Clones,
  Move,
  Controller,
  Arrows,
  Autoplay,
  Cover,
  Scroll,
  Drag,
  Keyboard,
  LazyLoad,
  Pagination,
  Sync,
  Wheel,
  Live
});
var I18N = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
};
var DEFAULTS = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: true,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  interval: 5e3,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: true,
  direction: "ltr",
  trimSpace: true,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: true,
  classes: CLASSES,
  i18n: I18N,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function Fade(Splide2, Components2, options) {
  var Slides2 = Components2.Slides;
  function mount() {
    EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
  }
  function init() {
    Slides2.forEach(function(Slide2) {
      Slide2.style("transform", "translateX(-" + 100 * Slide2.index + "%)");
    });
  }
  function start(index, done) {
    Slides2.style("transition", "opacity " + options.speed + "ms " + options.easing);
    nextTick(done);
  }
  return {
    mount,
    start,
    cancel: noop
  };
}
function Slide(Splide2, Components2, options) {
  var Move2 = Components2.Move, Controller2 = Components2.Controller, Scroll2 = Components2.Scroll;
  var list = Components2.Elements.list;
  var transition = apply(style, list, "transition");
  var endCallback;
  function mount() {
    EventInterface(Splide2).bind(list, "transitionend", function(e) {
      if (e.target === list && endCallback) {
        cancel();
        endCallback();
      }
    });
  }
  function start(index, done) {
    var destination = Move2.toPosition(index, true);
    var position = Move2.getPosition();
    var speed = getSpeed(index);
    if (abs(destination - position) >= 1 && speed >= 1) {
      if (options.useScroll) {
        Scroll2.scroll(destination, speed, false, done);
      } else {
        transition("transform " + speed + "ms " + options.easing);
        Move2.translate(destination, true);
        endCallback = done;
      }
    } else {
      Move2.jump(index);
      done();
    }
  }
  function cancel() {
    transition("");
    Scroll2.cancel();
  }
  function getSpeed(index) {
    var rewindSpeed = options.rewindSpeed;
    if (Splide2.is(SLIDE) && rewindSpeed) {
      var prev = Controller2.getIndex(true);
      var end = Controller2.getEnd();
      if (prev === 0 && index >= end || prev >= end && index === 0) {
        return rewindSpeed;
      }
    }
    return options.speed;
  }
  return {
    mount,
    start,
    cancel
  };
}
var _Splide = /* @__PURE__ */ function() {
  function _Splide2(target, options) {
    this.event = EventInterface();
    this.Components = {};
    this.state = State(CREATED);
    this.splides = [];
    this._o = {};
    this._E = {};
    var root = isString(target) ? query(document, target) : target;
    assert(root, root + " is invalid.");
    this.root = root;
    options = merge({
      label: getAttribute(root, ARIA_LABEL) || "",
      labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
    }, DEFAULTS, _Splide2.defaults, options || {});
    try {
      merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
    } catch (e) {
      assert(false, "Invalid JSON");
    }
    this._o = Object.create(merge({}, options));
  }
  var _proto = _Splide2.prototype;
  _proto.mount = function mount(Extensions, Transition) {
    var _this = this;
    var state = this.state, Components2 = this.Components;
    assert(state.is([CREATED, DESTROYED]), "Already mounted!");
    state.set(CREATED);
    this._C = Components2;
    this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
    this._E = Extensions || this._E;
    var Constructors = assign({}, ComponentConstructors, this._E, {
      Transition: this._T
    });
    forOwn(Constructors, function(Component, key) {
      var component = Component(_this, Components2, _this._o);
      Components2[key] = component;
      component.setup && component.setup();
    });
    forOwn(Components2, function(component) {
      component.mount && component.mount();
    });
    this.emit(EVENT_MOUNTED);
    addClass(this.root, CLASS_INITIALIZED);
    state.set(IDLE);
    this.emit(EVENT_READY);
    return this;
  };
  _proto.sync = function sync(splide) {
    this.splides.push({
      splide
    });
    splide.splides.push({
      splide: this,
      isParent: true
    });
    if (this.state.is(IDLE)) {
      this._C.Sync.remount();
      splide.Components.Sync.remount();
    }
    return this;
  };
  _proto.go = function go(control) {
    this._C.Controller.go(control);
    return this;
  };
  _proto.on = function on(events, callback) {
    this.event.on(events, callback);
    return this;
  };
  _proto.off = function off(events) {
    this.event.off(events);
    return this;
  };
  _proto.emit = function emit(event) {
    var _this$event;
    (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
    return this;
  };
  _proto.add = function add(slides, index) {
    this._C.Slides.add(slides, index);
    return this;
  };
  _proto.remove = function remove2(matcher) {
    this._C.Slides.remove(matcher);
    return this;
  };
  _proto.is = function is(type) {
    return this._o.type === type;
  };
  _proto.refresh = function refresh() {
    this.emit(EVENT_REFRESH);
    return this;
  };
  _proto.destroy = function destroy(completely) {
    if (completely === void 0) {
      completely = true;
    }
    var event = this.event, state = this.state;
    if (state.is(CREATED)) {
      EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
    } else {
      forOwn(this._C, function(component) {
        component.destroy && component.destroy(completely);
      }, true);
      event.emit(EVENT_DESTROY);
      event.destroy();
      completely && empty(this.splides);
      state.set(DESTROYED);
    }
    return this;
  };
  _createClass$4(_Splide2, [{
    key: "options",
    get: function get3() {
      return this._o;
    },
    set: function set2(options) {
      this._C.Media.set(options, true, true);
    }
  }, {
    key: "length",
    get: function get3() {
      return this._C.Slides.getLength(true);
    }
  }, {
    key: "index",
    get: function get3() {
      return this._C.Controller.getIndex();
    }
  }]);
  return _Splide2;
}();
var Splide = _Splide;
Splide.defaults = {};
Splide.STATES = STATES;
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
var HAS_DOM_2 = (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === "object";
function isDOMElement(obj) {
  return HAS_DOM_2 ? obj instanceof HTMLElement : obj && _typeof(obj) === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string";
}
function addClasses(el, classNames) {
  classNames.forEach(function(className) {
    el.classList.add(className);
  });
}
function removeClasses(el, classNames) {
  classNames.forEach(function(className) {
    el.classList.remove(className);
  });
}
var RULES = ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
function injectBaseStylesheet() {
  if (document.querySelector(".drift-base-styles")) {
    return;
  }
  var styleEl = document.createElement("style");
  styleEl.type = "text/css";
  styleEl.classList.add("drift-base-styles");
  styleEl.appendChild(document.createTextNode(RULES));
  var head = document.head;
  head.insertBefore(styleEl, head.firstChild);
}
function throwIfMissing() {
  throw new Error("Missing parameter");
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var BoundingBox = /* @__PURE__ */ function() {
  function BoundingBox2(options) {
    _classCallCheck$3(this, BoundingBox2);
    this.isShowing = false;
    var _options$namespace = options.namespace, namespace = _options$namespace === void 0 ? null : _options$namespace, _options$zoomFactor = options.zoomFactor, zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor, _options$containerEl = options.containerEl, containerEl = _options$containerEl === void 0 ? throwIfMissing() : _options$containerEl;
    this.settings = {
      namespace,
      zoomFactor,
      containerEl
    };
    this.openClasses = this._buildClasses("open");
    this._buildElement();
  }
  _createClass$3(BoundingBox2, [{
    key: "_buildClasses",
    value: function _buildClasses(suffix) {
      var classes = ["drift-".concat(suffix)];
      var ns = this.settings.namespace;
      if (ns) {
        classes.push("".concat(ns, "-").concat(suffix));
      }
      return classes;
    }
  }, {
    key: "_buildElement",
    value: function _buildElement() {
      this.el = document.createElement("div");
      addClasses(this.el, this._buildClasses("bounding-box"));
    }
  }, {
    key: "show",
    value: function show(zoomPaneWidth, zoomPaneHeight) {
      this.isShowing = true;
      this.settings.containerEl.appendChild(this.el);
      var style2 = this.el.style;
      style2.width = "".concat(Math.round(zoomPaneWidth / this.settings.zoomFactor), "px");
      style2.height = "".concat(Math.round(zoomPaneHeight / this.settings.zoomFactor), "px");
      addClasses(this.el, this.openClasses);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.isShowing) {
        this.settings.containerEl.removeChild(this.el);
      }
      this.isShowing = false;
      removeClasses(this.el, this.openClasses);
    }
  }, {
    key: "setPosition",
    value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
      var pageXOffset = window.pageXOffset;
      var pageYOffset = window.pageYOffset;
      var inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - this.el.clientWidth / 2 + pageXOffset;
      var inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - this.el.clientHeight / 2 + pageYOffset;
      if (inlineLeft < triggerRect.left + pageXOffset) {
        inlineLeft = triggerRect.left + pageXOffset;
      } else if (inlineLeft + this.el.clientWidth > triggerRect.left + triggerRect.width + pageXOffset) {
        inlineLeft = triggerRect.left + triggerRect.width - this.el.clientWidth + pageXOffset;
      }
      if (inlineTop < triggerRect.top + pageYOffset) {
        inlineTop = triggerRect.top + pageYOffset;
      } else if (inlineTop + this.el.clientHeight > triggerRect.top + triggerRect.height + pageYOffset) {
        inlineTop = triggerRect.top + triggerRect.height - this.el.clientHeight + pageYOffset;
      }
      this.el.style.left = "".concat(inlineLeft, "px");
      this.el.style.top = "".concat(inlineTop, "px");
    }
  }]);
  return BoundingBox2;
}();
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var Trigger = /* @__PURE__ */ function() {
  function Trigger2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$2(this, Trigger2);
    this._show = this._show.bind(this);
    this._hide = this._hide.bind(this);
    this._handleEntry = this._handleEntry.bind(this);
    this._handleMovement = this._handleMovement.bind(this);
    var _options$el = options.el, el = _options$el === void 0 ? throwIfMissing() : _options$el, _options$zoomPane = options.zoomPane, zoomPane = _options$zoomPane === void 0 ? throwIfMissing() : _options$zoomPane, _options$sourceAttrib = options.sourceAttribute, sourceAttribute = _options$sourceAttrib === void 0 ? throwIfMissing() : _options$sourceAttrib, _options$handleTouch = options.handleTouch, handleTouch = _options$handleTouch === void 0 ? throwIfMissing() : _options$handleTouch, _options$onShow = options.onShow, onShow = _options$onShow === void 0 ? null : _options$onShow, _options$onHide = options.onHide, onHide = _options$onHide === void 0 ? null : _options$onHide, _options$hoverDelay = options.hoverDelay, hoverDelay = _options$hoverDelay === void 0 ? 0 : _options$hoverDelay, _options$touchDelay = options.touchDelay, touchDelay = _options$touchDelay === void 0 ? 0 : _options$touchDelay, _options$hoverBoundin = options.hoverBoundingBox, hoverBoundingBox = _options$hoverBoundin === void 0 ? throwIfMissing() : _options$hoverBoundin, _options$touchBoundin = options.touchBoundingBox, touchBoundingBox = _options$touchBoundin === void 0 ? throwIfMissing() : _options$touchBoundin, _options$namespace = options.namespace, namespace = _options$namespace === void 0 ? null : _options$namespace, _options$zoomFactor = options.zoomFactor, zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor, _options$boundingBoxC = options.boundingBoxContainer, boundingBoxContainer = _options$boundingBoxC === void 0 ? throwIfMissing() : _options$boundingBoxC, _options$passive = options.passive, passive = _options$passive === void 0 ? false : _options$passive;
    this.settings = {
      el,
      zoomPane,
      sourceAttribute,
      handleTouch,
      onShow,
      onHide,
      hoverDelay,
      touchDelay,
      hoverBoundingBox,
      touchBoundingBox,
      namespace,
      zoomFactor,
      boundingBoxContainer,
      passive
    };
    if (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) {
      this.boundingBox = new BoundingBox({
        namespace: this.settings.namespace,
        zoomFactor: this.settings.zoomFactor,
        containerEl: this.settings.boundingBoxContainer
      });
    }
    this.enabled = true;
    this._bindEvents();
  }
  _createClass$2(Trigger2, [{
    key: "_preventDefault",
    value: function _preventDefault(event) {
      event.preventDefault();
    }
  }, {
    key: "_preventDefaultAllowTouchScroll",
    value: function _preventDefaultAllowTouchScroll(event) {
      if (!this.settings.touchDelay || !this._isTouchEvent(event) || this.isShowing) {
        event.preventDefault();
      }
    }
  }, {
    key: "_isTouchEvent",
    value: function _isTouchEvent(event) {
      return !!event.touches;
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      this.settings.el.addEventListener("mouseenter", this._handleEntry);
      this.settings.el.addEventListener("mouseleave", this._hide);
      this.settings.el.addEventListener("mousemove", this._handleMovement);
      var isPassive = {
        passive: this.settings.passive
      };
      if (this.settings.handleTouch) {
        this.settings.el.addEventListener("touchstart", this._handleEntry, isPassive);
        this.settings.el.addEventListener("touchend", this._hide);
        this.settings.el.addEventListener("touchmove", this._handleMovement, isPassive);
      } else {
        this.settings.el.addEventListener("touchstart", this._preventDefault, isPassive);
        this.settings.el.addEventListener("touchend", this._preventDefault);
        this.settings.el.addEventListener("touchmove", this._preventDefault, isPassive);
      }
    }
  }, {
    key: "_unbindEvents",
    value: function _unbindEvents() {
      this.settings.el.removeEventListener("mouseenter", this._handleEntry);
      this.settings.el.removeEventListener("mouseleave", this._hide);
      this.settings.el.removeEventListener("mousemove", this._handleMovement);
      if (this.settings.handleTouch) {
        this.settings.el.removeEventListener("touchstart", this._handleEntry);
        this.settings.el.removeEventListener("touchend", this._hide);
        this.settings.el.removeEventListener("touchmove", this._handleMovement);
      } else {
        this.settings.el.removeEventListener("touchstart", this._preventDefault);
        this.settings.el.removeEventListener("touchend", this._preventDefault);
        this.settings.el.removeEventListener("touchmove", this._preventDefault);
      }
    }
  }, {
    key: "_handleEntry",
    value: function _handleEntry(e) {
      this._preventDefaultAllowTouchScroll(e);
      this._lastMovement = e;
      if (e.type == "mouseenter" && this.settings.hoverDelay) {
        this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay);
      } else if (this.settings.touchDelay) {
        this.entryTimeout = setTimeout(this._show, this.settings.touchDelay);
      } else {
        this._show();
      }
    }
  }, {
    key: "_show",
    value: function _show() {
      if (!this.enabled) {
        return;
      }
      var onShow = this.settings.onShow;
      if (onShow && typeof onShow === "function") {
        onShow();
      }
      this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight);
      if (this._lastMovement) {
        var touchActivated = this._lastMovement.touches;
        if (touchActivated && this.settings.touchBoundingBox || !touchActivated && this.settings.hoverBoundingBox) {
          this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
        }
      }
      this._handleMovement();
    }
  }, {
    key: "_hide",
    value: function _hide(e) {
      if (e) {
        this._preventDefaultAllowTouchScroll(e);
      }
      this._lastMovement = null;
      if (this.entryTimeout) {
        clearTimeout(this.entryTimeout);
      }
      if (this.boundingBox) {
        this.boundingBox.hide();
      }
      var onHide = this.settings.onHide;
      if (onHide && typeof onHide === "function") {
        onHide();
      }
      this.settings.zoomPane.hide();
    }
  }, {
    key: "_handleMovement",
    value: function _handleMovement(e) {
      if (e) {
        this._preventDefaultAllowTouchScroll(e);
        this._lastMovement = e;
      } else if (this._lastMovement) {
        e = this._lastMovement;
      } else {
        return;
      }
      var movementX;
      var movementY;
      if (e.touches) {
        var firstTouch = e.touches[0];
        movementX = firstTouch.clientX;
        movementY = firstTouch.clientY;
      } else {
        movementX = e.clientX;
        movementY = e.clientY;
      }
      var el = this.settings.el;
      var rect2 = el.getBoundingClientRect();
      var offsetX = movementX - rect2.left;
      var offsetY = movementY - rect2.top;
      var percentageOffsetX = offsetX / this.settings.el.clientWidth;
      var percentageOffsetY = offsetY / this.settings.el.clientHeight;
      if (this.boundingBox) {
        this.boundingBox.setPosition(percentageOffsetX, percentageOffsetY, rect2);
      }
      this.settings.zoomPane.setPosition(percentageOffsetX, percentageOffsetY, rect2);
    }
  }, {
    key: "isShowing",
    get: function get3() {
      return this.settings.zoomPane.isShowing;
    }
  }]);
  return Trigger2;
}();
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var ZoomPane = /* @__PURE__ */ function() {
  function ZoomPane2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$1(this, ZoomPane2);
    this.HAS_ANIMATION = false;
    if (typeof document !== "undefined") {
      var divStyle = document.createElement("div").style;
      this.HAS_ANIMATION = "animation" in divStyle || "webkitAnimation" in divStyle;
    }
    this._completeShow = this._completeShow.bind(this);
    this._completeHide = this._completeHide.bind(this);
    this._handleLoad = this._handleLoad.bind(this);
    this.isShowing = false;
    var _options$container = options.container, container = _options$container === void 0 ? null : _options$container, _options$zoomFactor = options.zoomFactor, zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor, _options$inline = options.inline, inline = _options$inline === void 0 ? throwIfMissing() : _options$inline, _options$namespace = options.namespace, namespace = _options$namespace === void 0 ? null : _options$namespace, _options$showWhitespa = options.showWhitespaceAtEdges, showWhitespaceAtEdges = _options$showWhitespa === void 0 ? throwIfMissing() : _options$showWhitespa, _options$containInlin = options.containInline, containInline = _options$containInlin === void 0 ? throwIfMissing() : _options$containInlin, _options$inlineOffset = options.inlineOffsetX, inlineOffsetX = _options$inlineOffset === void 0 ? 0 : _options$inlineOffset, _options$inlineOffset2 = options.inlineOffsetY, inlineOffsetY = _options$inlineOffset2 === void 0 ? 0 : _options$inlineOffset2, _options$inlineContai = options.inlineContainer, inlineContainer = _options$inlineContai === void 0 ? document.body : _options$inlineContai;
    this.settings = {
      container,
      zoomFactor,
      inline,
      namespace,
      showWhitespaceAtEdges,
      containInline,
      inlineOffsetX,
      inlineOffsetY,
      inlineContainer
    };
    this.openClasses = this._buildClasses("open");
    this.openingClasses = this._buildClasses("opening");
    this.closingClasses = this._buildClasses("closing");
    this.inlineClasses = this._buildClasses("inline");
    this.loadingClasses = this._buildClasses("loading");
    this._buildElement();
  }
  _createClass$1(ZoomPane2, [{
    key: "_buildClasses",
    value: function _buildClasses(suffix) {
      var classes = ["drift-".concat(suffix)];
      var ns = this.settings.namespace;
      if (ns) {
        classes.push("".concat(ns, "-").concat(suffix));
      }
      return classes;
    }
  }, {
    key: "_buildElement",
    value: function _buildElement() {
      this.el = document.createElement("div");
      addClasses(this.el, this._buildClasses("zoom-pane"));
      var loaderEl = document.createElement("div");
      addClasses(loaderEl, this._buildClasses("zoom-pane-loader"));
      this.el.appendChild(loaderEl);
      this.imgEl = document.createElement("img");
      this.el.appendChild(this.imgEl);
    }
  }, {
    key: "_setImageURL",
    value: function _setImageURL(imageURL) {
      this.imgEl.setAttribute("src", imageURL);
    }
  }, {
    key: "_setImageSize",
    value: function _setImageSize(triggerWidth, triggerHeight) {
      this.imgEl.style.width = "".concat(triggerWidth * this.settings.zoomFactor, "px");
      this.imgEl.style.height = "".concat(triggerHeight * this.settings.zoomFactor, "px");
    }
    // `percentageOffsetX` and `percentageOffsetY` must be percentages
    // expressed as floats between `0' and `1`.
  }, {
    key: "setPosition",
    value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
      var imgElWidth = this.imgEl.offsetWidth;
      var imgElHeight = this.imgEl.offsetHeight;
      var elWidth = this.el.offsetWidth;
      var elHeight = this.el.offsetHeight;
      var centreOfContainerX = elWidth / 2;
      var centreOfContainerY = elHeight / 2;
      var targetImgXToBeCentre = imgElWidth * percentageOffsetX;
      var targetImgYToBeCentre = imgElHeight * percentageOffsetY;
      var left = centreOfContainerX - targetImgXToBeCentre;
      var top = centreOfContainerY - targetImgYToBeCentre;
      var differenceBetweenContainerWidthAndImgWidth = elWidth - imgElWidth;
      var differenceBetweenContainerHeightAndImgHeight = elHeight - imgElHeight;
      var isContainerLargerThanImgX = differenceBetweenContainerWidthAndImgWidth > 0;
      var isContainerLargerThanImgY = differenceBetweenContainerHeightAndImgHeight > 0;
      var minLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : 0;
      var minTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : 0;
      var maxLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : differenceBetweenContainerWidthAndImgWidth;
      var maxTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : differenceBetweenContainerHeightAndImgHeight;
      if (this.el.parentElement === this.settings.inlineContainer) {
        var scrollX = window.pageXOffset;
        var scrollY = window.pageYOffset;
        var inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - elWidth / 2 + this.settings.inlineOffsetX + scrollX;
        var inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - elHeight / 2 + this.settings.inlineOffsetY + scrollY;
        if (this.settings.containInline) {
          if (inlineLeft < triggerRect.left + scrollX) {
            inlineLeft = triggerRect.left + scrollX;
          } else if (inlineLeft + elWidth > triggerRect.left + triggerRect.width + scrollX) {
            inlineLeft = triggerRect.left + triggerRect.width - elWidth + scrollX;
          }
          if (inlineTop < triggerRect.top + scrollY) {
            inlineTop = triggerRect.top + scrollY;
          } else if (inlineTop + elHeight > triggerRect.top + triggerRect.height + scrollY) {
            inlineTop = triggerRect.top + triggerRect.height - elHeight + scrollY;
          }
        }
        this.el.style.left = "".concat(inlineLeft, "px");
        this.el.style.top = "".concat(inlineTop, "px");
      }
      if (!this.settings.showWhitespaceAtEdges) {
        if (left > minLeft) {
          left = minLeft;
        } else if (left < maxLeft) {
          left = maxLeft;
        }
        if (top > minTop) {
          top = minTop;
        } else if (top < maxTop) {
          top = maxTop;
        }
      }
      this.imgEl.style.transform = "translate(".concat(left, "px, ").concat(top, "px)");
      this.imgEl.style.webkitTransform = "translate(".concat(left, "px, ").concat(top, "px)");
    }
  }, {
    key: "_removeListenersAndResetClasses",
    value: function _removeListenersAndResetClasses() {
      this.el.removeEventListener("animationend", this._completeShow);
      this.el.removeEventListener("animationend", this._completeHide);
      this.el.removeEventListener("webkitAnimationEnd", this._completeShow);
      this.el.removeEventListener("webkitAnimationEnd", this._completeHide);
      removeClasses(this.el, this.openClasses);
      removeClasses(this.el, this.closingClasses);
    }
  }, {
    key: "show",
    value: function show(imageURL, triggerWidth, triggerHeight) {
      this._removeListenersAndResetClasses();
      this.isShowing = true;
      addClasses(this.el, this.openClasses);
      if (this.imgEl.getAttribute("src") != imageURL) {
        addClasses(this.el, this.loadingClasses);
        this.imgEl.addEventListener("load", this._handleLoad);
        this._setImageURL(imageURL);
      }
      this._setImageSize(triggerWidth, triggerHeight);
      if (this._isInline) {
        this._showInline();
      } else {
        this._showInContainer();
      }
      if (this.HAS_ANIMATION) {
        this.el.addEventListener("animationend", this._completeShow);
        this.el.addEventListener("webkitAnimationEnd", this._completeShow);
        addClasses(this.el, this.openingClasses);
      }
    }
  }, {
    key: "_showInline",
    value: function _showInline() {
      this.settings.inlineContainer.appendChild(this.el);
      addClasses(this.el, this.inlineClasses);
    }
  }, {
    key: "_showInContainer",
    value: function _showInContainer() {
      this.settings.container.appendChild(this.el);
    }
  }, {
    key: "hide",
    value: function hide() {
      this._removeListenersAndResetClasses();
      this.isShowing = false;
      if (this.HAS_ANIMATION) {
        this.el.addEventListener("animationend", this._completeHide);
        this.el.addEventListener("webkitAnimationEnd", this._completeHide);
        addClasses(this.el, this.closingClasses);
      } else {
        removeClasses(this.el, this.openClasses);
        removeClasses(this.el, this.inlineClasses);
      }
    }
  }, {
    key: "_completeShow",
    value: function _completeShow() {
      this.el.removeEventListener("animationend", this._completeShow);
      this.el.removeEventListener("webkitAnimationEnd", this._completeShow);
      removeClasses(this.el, this.openingClasses);
    }
  }, {
    key: "_completeHide",
    value: function _completeHide() {
      this.el.removeEventListener("animationend", this._completeHide);
      this.el.removeEventListener("webkitAnimationEnd", this._completeHide);
      removeClasses(this.el, this.openClasses);
      removeClasses(this.el, this.closingClasses);
      removeClasses(this.el, this.inlineClasses);
      this.el.style.left = "";
      this.el.style.top = "";
      if (this.el.parentElement === this.settings.container) {
        this.settings.container.removeChild(this.el);
      } else if (this.el.parentElement === this.settings.inlineContainer) {
        this.settings.inlineContainer.removeChild(this.el);
      }
    }
  }, {
    key: "_handleLoad",
    value: function _handleLoad() {
      this.imgEl.removeEventListener("load", this._handleLoad);
      removeClasses(this.el, this.loadingClasses);
    }
  }, {
    key: "_isInline",
    get: function get3() {
      var inline = this.settings.inline;
      return inline === true || typeof inline === "number" && window.innerWidth <= inline;
    }
  }]);
  return ZoomPane2;
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var Drift = /* @__PURE__ */ function() {
  function Drift2(triggerEl) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Drift2);
    this.VERSION = "1.5.1";
    this.triggerEl = triggerEl;
    this.destroy = this.destroy.bind(this);
    if (!isDOMElement(this.triggerEl)) {
      throw new TypeError("`new Drift` requires a DOM element as its first argument.");
    }
    var namespace = options["namespace"] || null;
    var showWhitespaceAtEdges = options["showWhitespaceAtEdges"] || false;
    var containInline = options["containInline"] || false;
    var inlineOffsetX = options["inlineOffsetX"] || 0;
    var inlineOffsetY = options["inlineOffsetY"] || 0;
    var inlineContainer = options["inlineContainer"] || document.body;
    var sourceAttribute = options["sourceAttribute"] || "data-zoom";
    var zoomFactor = options["zoomFactor"] || 3;
    var paneContainer = options["paneContainer"] === void 0 ? document.body : options["paneContainer"];
    var inlinePane = options["inlinePane"] || 375;
    var handleTouch = "handleTouch" in options ? !!options["handleTouch"] : true;
    var onShow = options["onShow"] || null;
    var onHide = options["onHide"] || null;
    var injectBaseStyles = "injectBaseStyles" in options ? !!options["injectBaseStyles"] : true;
    var hoverDelay = options["hoverDelay"] || 0;
    var touchDelay = options["touchDelay"] || 0;
    var hoverBoundingBox = options["hoverBoundingBox"] || false;
    var touchBoundingBox = options["touchBoundingBox"] || false;
    var boundingBoxContainer = options["boundingBoxContainer"] || document.body;
    var passive = options["passive"] || false;
    if (inlinePane !== true && !isDOMElement(paneContainer)) {
      throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
    }
    if (!isDOMElement(inlineContainer)) {
      throw new TypeError("`inlineContainer` must be a DOM element");
    }
    this.settings = {
      namespace,
      showWhitespaceAtEdges,
      containInline,
      inlineOffsetX,
      inlineOffsetY,
      inlineContainer,
      sourceAttribute,
      zoomFactor,
      paneContainer,
      inlinePane,
      handleTouch,
      onShow,
      onHide,
      injectBaseStyles,
      hoverDelay,
      touchDelay,
      hoverBoundingBox,
      touchBoundingBox,
      boundingBoxContainer,
      passive
    };
    if (this.settings.injectBaseStyles) {
      injectBaseStylesheet();
    }
    this._buildZoomPane();
    this._buildTrigger();
  }
  _createClass(Drift2, [{
    key: "_buildZoomPane",
    value: function _buildZoomPane() {
      this.zoomPane = new ZoomPane({
        container: this.settings.paneContainer,
        zoomFactor: this.settings.zoomFactor,
        showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
        containInline: this.settings.containInline,
        inline: this.settings.inlinePane,
        namespace: this.settings.namespace,
        inlineOffsetX: this.settings.inlineOffsetX,
        inlineOffsetY: this.settings.inlineOffsetY,
        inlineContainer: this.settings.inlineContainer
      });
    }
  }, {
    key: "_buildTrigger",
    value: function _buildTrigger() {
      this.trigger = new Trigger({
        el: this.triggerEl,
        zoomPane: this.zoomPane,
        handleTouch: this.settings.handleTouch,
        onShow: this.settings.onShow,
        onHide: this.settings.onHide,
        sourceAttribute: this.settings.sourceAttribute,
        hoverDelay: this.settings.hoverDelay,
        touchDelay: this.settings.touchDelay,
        hoverBoundingBox: this.settings.hoverBoundingBox,
        touchBoundingBox: this.settings.touchBoundingBox,
        namespace: this.settings.namespace,
        zoomFactor: this.settings.zoomFactor,
        boundingBoxContainer: this.settings.boundingBoxContainer,
        passive: this.settings.passive
      });
    }
  }, {
    key: "setZoomImageURL",
    value: function setZoomImageURL(imageURL) {
      this.zoomPane._setImageURL(imageURL);
    }
  }, {
    key: "disable",
    value: function disable() {
      this.trigger.enabled = false;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.trigger.enabled = true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.trigger._hide();
      this.trigger._unbindEvents();
    }
  }, {
    key: "isShowing",
    get: function get3() {
      return this.zoomPane.isShowing;
    }
  }, {
    key: "zoomFactor",
    get: function get3() {
      return this.settings.zoomFactor;
    },
    set: function set2(zf) {
      this.settings.zoomFactor = zf;
      this.zoomPane.settings.zoomFactor = zf;
      this.trigger.settings.zoomFactor = zf;
      this.boundingBox.settings.zoomFactor = zf;
    }
  }]);
  return Drift2;
}();
Object.defineProperty(Drift.prototype, "isShowing", {
  get: function get() {
    return this.isShowing;
  }
});
Object.defineProperty(Drift.prototype, "zoomFactor", {
  get: function get2() {
    return this.zoomFactor;
  },
  set: function set(value) {
    this.zoomFactor = value;
  }
});
Drift.prototype["setZoomImageURL"] = Drift.prototype.setZoomImageURL;
Drift.prototype["disable"] = Drift.prototype.disable;
Drift.prototype["enable"] = Drift.prototype.enable;
Drift.prototype["destroy"] = Drift.prototype.destroy;
class ProductImageZoom {
  constructor({
    overlaysClass = "jk-hover-zoom-overlay",
    zoomMobileClass = "zoom-mobile",
    mainGallerySelector = ".gallery-item",
    zoomContainerSelector = "#image-zoom-container",
    photosSelector = ".gallery-item",
    productElSelector = "product",
    productEssentials = "redesign-product-essentials",
    zoomEnabled = true,
    breakpoint = 1e3,
    mainSplide = null
  } = {}, root = document) {
    __publicField(this, "zoomTouchStart", (event) => {
      if (event.touches.length === 2) {
        this.mainSplide.options = { drag: false };
        event.preventDefault();
        event.currentTarget.style.transition = "";
        this.start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
        this.start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
        this.start.distance = this.distance(event);
      }
    });
    __publicField(this, "zoomTouchMove", (event) => {
      if (event.touches.length === 2) {
        this.mainSplide.options = { drag: false };
        event.preventDefault();
        const scale = event.scale || this.distance(event) / this.start.distance;
        this.imageElementScale = Math.min(Math.max(1, scale), 4);
        const deltaX = ((event.touches[0].pageX + event.touches[1].pageX) / 2 - this.start.x) * 2;
        const deltaY = ((event.touches[0].pageY + event.touches[1].pageY) / 2 - this.start.y) * 2;
        const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${this.imageElementScale})`;
        event.currentTarget.style.transform = transform;
        event.currentTarget.style.WebkitTransform = transform;
        event.currentTarget.style.zIndex = "9999";
      }
    });
    __publicField(this, "zoomTouchEnd", (event) => {
      if (event.touches.length === 0) {
        this.mainSplide.options = { drag: true };
        event.currentTarget.style.transform = "";
        event.currentTarget.style.WebkitTransform = "";
        event.currentTarget.style.zIndex = "";
        event.currentTarget.style.transition = "all .5s";
      }
    });
    this.rootInstance = root;
    this.breakpoint = breakpoint;
    this.zoomEnabled = zoomEnabled;
    this.mainSplide = mainSplide;
    this.$body = document.body;
    this.$zoomItems = this.rootInstance.querySelectorAll(`.${overlaysClass}`);
    this.$zoomMobileElement = this.rootInstance.querySelector(`.${zoomMobileClass}`);
    this.$mainGalleryImages = this.rootInstance.querySelectorAll(mainGallerySelector);
    this.$zoomImgs = this.rootInstance.querySelectorAll(photosSelector);
    this.zoomContainer = this.rootInstance.querySelector(zoomContainerSelector);
    this.productEssentials = this.rootInstance.querySelector(`.${productEssentials}`);
    this.driftInit = false;
    this.productEl = this.rootInstance.getElementById(productElSelector);
    this.MIN_WIDTH = 129;
    this.MIN_HEIGHT = 154;
    this.OVERLAY_HALF_WIDTH = 129 / 2;
    this.OVERLAY_HALF_HEIGHT = 154 / 2;
    this.start = { x: 0, y: 0, distance: 0 };
    this.imageElementScale = 1;
    this.options = {
      sourceAttribute: "data-zoom",
      zoomFactor: 3,
      paneContainer: this.zoomContainer,
      inlinePane: false,
      handleTouch: false,
      injectBaseStyles: true,
      hoverDelay: 400,
      touchDelay: 0,
      hoverBoundingBox: true,
      touchBoundingBox: false,
      passive: false,
      onShow: () => {
        var _a;
        const imgZoomResultBg = (_a = this.productEl) == null ? void 0 : _a.querySelector(".img-zoom-result-bg");
        imgZoomResultBg.classList.remove("hidden");
        _JK.helpers.addClass(this.zoomContainer, "h-492", "w-412", "absolute");
        _JK.helpers.removeClass(this.zoomContainer, "h-0");
        const containerRect = this.productEl.getBoundingClientRect();
        if (containerRect.top > 0) {
          this.zoomContainer.style.top = `${containerRect.top + window.scrollY}px`;
        } else {
          this.zoomContainer.style.top = `${window.scrollY}px`;
        }
      },
      onHide: () => {
        var _a;
        const imgZoomResultBg = (_a = this.productEl) == null ? void 0 : _a.querySelector(".img-zoom-result-bg");
        imgZoomResultBg.classList.add("hidden");
        this.zoomContainer.classList.remove("absolute", "h-492", "w-412");
        this.zoomContainer.classList.add("absolute", "h-0", "w-0");
      }
    };
    this.initModelSizes();
    this.handleResponsiveEvents = this.debounce(this.handleResponsiveEvents.bind(this), 150);
    this.handleResponsiveEvents();
    window.addEventListener("resize", this.handleResponsiveEvents);
  }
  init() {
    this.initDrift = this.debounce(this.initDrift.bind(this), 150);
    this.initDrift();
    this.initZoomHoverEffect();
    onResizeDebounced(this.initDrift);
  }
  // Allows dynamic assignment of Splide instance for drag control
  setSplide(splideInstance) {
    this.mainSplide = splideInstance;
  }
  initDrift() {
    const width = window.innerWidth;
    if (!this.zoomEnabled) return;
    if (width >= this.breakpoint && !this.driftInit) {
      this.$zoomImgs.forEach((item) => {
        const img = item.querySelector("img");
        if (img) {
          const setupDrift = () => new Drift(img, this.options);
          if (img.complete) {
            setupDrift();
          } else {
            img.onload = setupDrift;
          }
        }
      });
      this.driftInit = true;
    } else if (width < this.breakpoint && this.driftInit) {
      this.driftInit = false;
    }
  }
  initZoomHoverEffect() {
    if (!this.zoomEnabled || !this.$mainGalleryImages.length) return;
    this.$mainGalleryImages.forEach((container) => {
      container.addEventListener("mousemove", (e) => this.updateOverlay(e));
      container.addEventListener("mouseleave", () => {
        this.$zoomItems.forEach((item) => {
          item.style.opacity = 0;
          item.style.height = "0px";
          removeClass$1(item, "lg:block");
        });
      });
    });
  }
  initModelSizes() {
    var _a;
    const raw = (_a = this.rootInstance.getElementById("model-sizes-json")) == null ? void 0 : _a.textContent;
    if (!raw) return;
    try {
      const modelSizes = JSON.parse(raw);
      Object.entries(modelSizes).forEach(([index, value]) => {
        const galleryCarousel = this.rootInstance.querySelector(`[data-model-sizes="gallery-carousel-${index}"]`);
        const galleryGrid = this.rootInstance.querySelector(`[data-model-sizes="gallery-grid-${index}"]`);
        if (galleryCarousel || galleryGrid) {
          const wrapper = this.rootInstance.createElement("div");
          wrapper.className = "absolute bg-ivory backdrop-blur-2 px-9 left-16 bottom-16 pt-6 pb-5 redesign-body-9 text-charcoal-100 max-w-[calc(100%-32px)]";
          wrapper.textContent = value;
          galleryCarousel == null ? void 0 : galleryCarousel.appendChild(wrapper.cloneNode(true));
          galleryGrid == null ? void 0 : galleryGrid.appendChild(wrapper.cloneNode(true));
        }
      });
    } catch (e) {
      console.error("Invalid JSON in model sizes metafield:", e);
    }
  }
  updateOverlay(e) {
    const target = e.currentTarget;
    const img = target.querySelector("img");
    if (!img) return;
    const rect2 = img.getBoundingClientRect();
    const x = e.pageX - rect2.left - window.pageXOffset;
    const y = e.pageY - rect2.top - window.pageYOffset;
    const imgHeight = img.offsetHeight;
    const imgWidth = img.offsetWidth;
    let rightX = imgWidth - (x + this.OVERLAY_HALF_WIDTH);
    let leftX = x - this.OVERLAY_HALF_WIDTH;
    let bottomY = y + this.OVERLAY_HALF_HEIGHT;
    let topY = y - this.OVERLAY_HALF_HEIGHT;
    if (x + this.OVERLAY_HALF_WIDTH > imgWidth) {
      rightX = 0;
      leftX = imgWidth - this.MIN_WIDTH;
    } else if (leftX < 0) {
      leftX = 0;
      rightX = imgWidth - this.MIN_WIDTH;
    }
    if (topY < 0) {
      topY = 0;
      bottomY = this.MIN_HEIGHT;
    } else if (bottomY > imgHeight) {
      bottomY = imgHeight;
      topY = imgHeight - this.MIN_HEIGHT;
    }
    target.querySelectorAll(".jk-hover-zoom-overlay").forEach((item) => {
      item.style.opacity = 0.6;
      addClass$1(item, "lg:block");
    });
    const top = target.querySelector(".top");
    const bottom = target.querySelector(".bottom");
    const left = target.querySelector(".left");
    const right = target.querySelector(".right");
    if (top) top.style.height = `${topY}px`;
    if (bottom) {
      bottom.style.top = `${bottomY}px`;
      bottom.style.height = `${imgHeight - bottomY}px`;
    }
    if (left) {
      left.style.top = `${topY}px`;
      left.style.height = `${this.MIN_HEIGHT}px`;
      left.style.width = `${leftX}px`;
    }
    if (right) {
      right.style.top = `${topY}px`;
      right.style.height = `${this.MIN_HEIGHT}px`;
      right.style.width = `${rightX}px`;
    }
  }
  handleResponsiveEvents() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    if (isMobile && !this.eventsBound) {
      this.bindEvents();
      this.eventsBound = true;
    } else if (!isMobile && this.eventsBound) {
      this.unbindEvents();
      this.eventsBound = false;
    }
  }
  bindEvents() {
    this.zoomClickHandler = () => {
      this.$body.classList.add("carousel-visible");
      this.enablePinchZoom();
    };
    this.closeClickHandler = () => {
      this.$body.classList.remove("carousel-visible");
      this.destroyPinchListeners();
    };
    if (this.$zoomMobileElement) {
      this.$zoomMobileElement.addEventListener("click", this.zoomClickHandler);
    }
    this.closeBtn = this.rootInstance.getElementById("close-mobile-zoom");
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", this.closeClickHandler);
    }
  }
  unbindEvents() {
    if (this.$zoomMobileElement && this.zoomClickHandler) {
      this.$zoomMobileElement.removeEventListener("click", this.zoomClickHandler);
    }
    if (this.closeBtn && this.closeClickHandler) {
      this.closeBtn.removeEventListener("click", this.closeClickHandler);
    }
    this.destroyPinchListeners();
  }
  distance(event) {
    const dx = event.touches[0].pageX - event.touches[1].pageX;
    const dy = event.touches[0].pageY - event.touches[1].pageY;
    return Math.sqrt(dx * dx + dy * dy);
  }
  enablePinchZoom() {
    this.rootInstance.querySelectorAll(".splide__slide img").forEach((item) => {
      item.addEventListener("touchstart", this.zoomTouchStart, { passive: false });
      item.addEventListener("touchmove", this.zoomTouchMove, { passive: false });
      item.addEventListener("touchend", this.zoomTouchEnd);
    });
  }
  destroyPinchListeners() {
    this.rootInstance.querySelectorAll(".splide__slide img").forEach((item) => {
      item.removeEventListener("touchstart", this.zoomTouchStart);
      item.removeEventListener("touchmove", this.zoomTouchMove);
      item.removeEventListener("touchend", this.zoomTouchEnd);
    });
  }
  debounce(fn, delay) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}
const _ProductGallery = class _ProductGallery {
  //Track existing instances per selector.
  constructor(mainSelector, thumbsSelector, mobileBreakpoint = 1024, options = {}, isCustomConfig = false) {
    var _a, _b;
    const existingInstance = _ProductGallery.instances.get(mainSelector);
    if (existingInstance) {
      existingInstance.destroy();
    }
    _ProductGallery.instances.set(mainSelector, this);
    this.mainSelector = mainSelector;
    this.thumbsSelector = thumbsSelector;
    this.mobileBreakpoint = mobileBreakpoint;
    this.defaultSplideConfig = {
      type: "slide",
      drag: true,
      perPage: 1,
      pagination: false,
      arrows: false,
      heightRatio: 1,
      cover: true,
      keyboard: "global",
      breakpoints: {
        1023: {
          drag: true,
          dragMinThreshold: { touch: 10 },
          perPage: 1,
          perMove: 1,
          heightRatio: 1.19907407407,
          autoHeight: true
        }
      }
    };
    this.options = {
      useThumbs: isCustomConfig ? options.useThumbs : true,
      thumbsOn: isCustomConfig ? options.thumbsOn : "all",
      splideConfig: isCustomConfig ? options.splideOptions : this.defaultSplideConfig
    };
    this.mainSplide = null;
    this.thumbSplide = null;
    this.videos = document.querySelectorAll(".custom-video");
    this.galleryEl = this.resolveEl(mainSelector, document);
    this.zoomEnabled = ((_b = (_a = this.galleryEl) == null ? void 0 : _a.dataset) == null ? void 0 : _b.zoomStatus) !== "false";
    this.imageZoom = new ProductImageZoom({ zoomEnabled: this.zoomEnabled });
    this.init();
    this.bindResize();
    this.initVideoControls();
    this.initScrollPause();
  }
  init() {
    const mode = window.innerWidth < this.mobileBreakpoint ? "mobile" : "desktop";
    this.mountSplide(mode);
    if (mode === "desktop") this.imageZoom.init();
  }
  mountSplide(mode) {
    this.currentMode = mode;
    const shouldUseThumbs = this.options.useThumbs && (this.options.thumbsOn === "all" || this.options.thumbsOn === "mobile" && mode === "mobile");
    if (shouldUseThumbs && !this.thumbSplide) {
      this.thumbSplide = new Splide(this.thumbsSelector, {
        fixedWidth: 80,
        fixedHeight: 80,
        isNavigation: true,
        gap: 8,
        focus: "start",
        pagination: false,
        arrows: false,
        cover: true,
        keyboard: "global",
        breakpoints: { 1023: { fixedWidth: 52, fixedHeight: 62 } }
      }).mount();
    }
    if (!this.mainSplide) {
      const splideConfig = { ...this.options.splideConfig, start: this.lastIndex };
      this.mainSplide = new Splide(this.mainSelector, splideConfig);
      if (this.thumbSplide) this.mainSplide.sync(this.thumbSplide);
      this.mainSplide.on("moved", (newIndex) => {
        var _a;
        this.lastIndex = newIndex;
        this.pauseAllVideos();
        const activeSlide = (_a = this.mainSplide.Components.Slides.getAt(newIndex)) == null ? void 0 : _a.slide;
        if (!activeSlide) return;
        const video = activeSlide.querySelector(".custom-video.autoplay");
        const activeControl = activeSlide.querySelector(".video-control.autoplay");
        if (video && typeof video.play === "function") {
          video.play();
          activeControl.querySelector(".icon-play").classList.add("hidden");
          activeControl.querySelector(".icon-pause").classList.remove("hidden");
          activeControl.setAttribute("aria-label", "Pause video");
        }
      });
      this.mainSplide.mount();
      this.imageZoom.setSplide(this.mainSplide);
    }
  }
  resolveEl(target, root = document) {
    if (typeof target === "string") return root.querySelector(target);
    if (target instanceof Element) return target;
    return null;
  }
  destroySplide() {
    if (this.mainSplide) {
      this.lastIndex = this.mainSplide.index;
      this.mainSplide.destroy();
      this.mainSplide = null;
    }
    if (this.thumbSplide) {
      this.thumbSplide.destroy();
      this.thumbSplide = null;
    }
  }
  checkResize() {
    var _a, _b;
    const mode = window.innerWidth < this.mobileBreakpoint ? "mobile" : "desktop";
    if (mode !== this.currentMode) {
      this.destroySplide();
      this.mountSplide(mode);
      if (mode === "desktop") this.imageZoom.init();
    } else {
      (_a = this.mainSplide) == null ? void 0 : _a.refresh();
      (_b = this.thumbSplide) == null ? void 0 : _b.refresh();
    }
  }
  bindResize() {
    this.checkResize = this.throttle(this.checkResize.bind(this), 150);
    window.addEventListener("resize", this.checkResize);
  }
  destroy() {
    this.destroySplide();
    window.removeEventListener("resize", this.checkResize);
    _ProductGallery.instances.delete(this.mainSelector);
  }
  initVideoControls() {
    this.videos.forEach((video) => {
      const wrapper = video.closest(".video-wrapper");
      const controlButton = wrapper == null ? void 0 : wrapper.querySelector(".video-control");
      const playIcon = controlButton == null ? void 0 : controlButton.querySelector(".icon-play");
      const pauseIcon = controlButton == null ? void 0 : controlButton.querySelector(".icon-pause");
      if (!controlButton || !playIcon || !pauseIcon || !wrapper) return;
      if (video.classList.contains("autoplay")) {
        playIcon.classList.add("hidden");
        pauseIcon.classList.remove("hidden");
        controlButton.setAttribute("aria-label", "Pause video");
      }
      controlButton.addEventListener("click", () => {
        if (video.paused) {
          this.pauseAllVideos(video);
          video.play();
          playIcon.classList.add("hidden");
          pauseIcon.classList.remove("hidden");
          controlButton.setAttribute("aria-label", "Pause video");
          video.classList.add("autoplay");
          controlButton.classList.add("autoplay");
        } else {
          video.pause();
          playIcon.classList.remove("hidden");
          pauseIcon.classList.add("hidden");
          controlButton.setAttribute("aria-label", "Play video");
          video.classList.remove("autoplay");
          controlButton.classList.remove("autoplay");
        }
      });
      video.addEventListener("ended", () => {
        playIcon.classList.remove("hidden");
        pauseIcon.classList.add("hidden");
        controlButton.setAttribute("aria-label", "Play video");
      });
      video.addEventListener("waiting", () => {
        wrapper.classList.add("video-buffering");
      });
      video.addEventListener("playing", () => {
        wrapper.classList.remove("video-buffering");
      });
    });
  }
  pauseAllVideos(exceptVideo = null) {
    this.videos.forEach((video) => {
      if (video !== exceptVideo && typeof video.pause === "function") {
        video.pause();
        const wrapper = video.closest(".video-wrapper");
        const controlButton = wrapper == null ? void 0 : wrapper.querySelector(".video-control");
        const playIcon = controlButton == null ? void 0 : controlButton.querySelector(".icon-play");
        const pauseIcon = controlButton == null ? void 0 : controlButton.querySelector(".icon-pause");
        if (controlButton && playIcon && pauseIcon) {
          playIcon.classList.remove("hidden");
          pauseIcon.classList.add("hidden");
          controlButton.setAttribute("aria-label", "Play video");
        }
      }
    });
  }
  initScrollPause() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (!entry.isIntersecting) {
          if (el.tagName === "VIDEO" && typeof el.pause === "function") {
            if (!el.classList.contains("autoplay")) {
              el.pause();
            }
            const wrapper = el.closest(".video-wrapper");
            const controlButton = wrapper == null ? void 0 : wrapper.querySelector(".video-control");
            const playIcon = controlButton == null ? void 0 : controlButton.querySelector(".icon-play");
            const pauseIcon = controlButton == null ? void 0 : controlButton.querySelector(".icon-pause");
            if (controlButton && playIcon && pauseIcon) {
              playIcon.classList.remove("hidden");
              pauseIcon.classList.add("hidden");
              controlButton.setAttribute("aria-label", "Play video");
              if (el.classList.contains("autoplay")) {
                playIcon.classList.add("hidden");
                pauseIcon.classList.remove("hidden");
                controlButton.setAttribute("aria-label", "Pause video");
              }
            }
          }
        }
      });
    }, { threshold: 0.25 });
    this.videos.forEach((video) => {
      observer.observe(video);
    });
  }
  throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
      const now = (/* @__PURE__ */ new Date()).getTime();
      if (now - lastCall < delay) return;
      lastCall = now;
      return fn(...args);
    };
  }
};
__publicField(_ProductGallery, "instances", /* @__PURE__ */ new Map());
let ProductGallery = _ProductGallery;
function productQty(root = document, productFormDOM) {
  root.querySelectorAll(".product-form--wrapper").forEach((wrapper) => {
    const productForm = productFormDOM || wrapper.querySelector("#addToBagForm");
    if (!productForm) return;
    const qtyInputs = productForm.querySelectorAll(".js-input-qty");
    const qtyText = productForm.querySelector(".js-text-qty");
    qtyInputs.forEach((input) => {
      const wrapper2 = input.closest(".item__quantity-wrapper");
      if (!wrapper2) return;
      const incrementBtn = wrapper2.querySelector(".js-change-qty.plus");
      const decrementBtn = wrapper2.querySelector(".js-change-qty.minus");
      const updateButtonStates = (value) => {
        if (decrementBtn) decrementBtn.disabled = value <= 1;
        if (incrementBtn) incrementBtn.disabled = value >= 99;
        if (qtyText) qtyText.innerText = value;
      };
      const updateQuantity = (change) => {
        let currentValue = parseInt(input.value, 10) || 1;
        let newValue = currentValue + change;
        if (newValue < 1) newValue = 1;
        if (newValue > 99) newValue = 99;
        input.value = newValue;
        updateButtonStates(newValue);
      };
      updateButtonStates(parseInt(input.value, 10));
      if (decrementBtn) {
        decrementBtn.addEventListener("click", () => updateQuantity(-1));
      }
      if (incrementBtn) {
        incrementBtn.addEventListener("click", () => updateQuantity(1));
      }
    });
  });
}
function validateOptionSelected(productContainer = document) {
  const options = productContainer.querySelectorAll("body .js-option");
  const currentSize = productContainer.querySelector(".js-config-current-size");
  removeClass$1(currentSize, "text-red-100");
  if (currentSize && currentSize.textContent.trim().startsWith("Please")) {
    currentSize.textContent = currentSize.textContent.trim().replace(/^Please\s*/, "");
  }
  let selected = false;
  if (options.length === 0) {
    selected = true;
  }
  const optionsArray = Array.from(options);
  selected = optionsArray.length === 1 || optionsArray.some((item) => hasClass$1(item, "is-active")) || optionsArray.length === 0;
  if (!selected && currentSize) {
    addClass$1(currentSize, "text-red-100");
    if (currentSize && !currentSize.textContent.trim().startsWith("Please")) {
      currentSize.textContent = `Please ${currentSize.textContent.trim().toLowerCase()}`;
    }
    currentSize.scrollIntoView({
      block: "center",
      behavior: "smooth"
    });
    return false;
  }
  return true;
}
function giftcardFormIsValid(productContainer = document) {
  const form = productContainer.querySelector("#giftcardForm");
  if (!form) return false;
  const $variant = document.querySelector('[name="id"]');
  const $name = form.querySelector("#giftcard_recipient_name");
  const $email = form.querySelector("#giftcard_recipient_email");
  const $note = form.querySelector("#giftcard_note");
  const $date = form.querySelector("#giftcard_delivery_date");
  const $time = form.querySelector("#delivery-time");
  const noteRegex = /^[a-zA-ZÀ-ÿ0-9\s.,'"\-!@#$%^&*()_+=:;/?]*$/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
  function setError(element, alertElement, message) {
    element.classList.remove("border-charcoal-10");
    element.classList.add("border-red-100");
    element.setAttribute("aria-invalid", "true");
    if (alertElement) {
      alertElement.textContent = message;
      alertElement.classList.remove("hidden");
    } else {
      console.warn(`Missing .alert for`, element);
    }
  }
  function clearError(element, alertElement) {
    element.classList.remove("border-red-100");
    element.classList.add("border-charcoal-10");
    element.setAttribute("aria-invalid", "false");
    if (alertElement) {
      alertElement.classList.add("hidden");
    }
  }
  function getAlert(element) {
    var _a;
    return (_a = element == null ? void 0 : element.parentElement) == null ? void 0 : _a.querySelector(".alert");
  }
  function validateVariantSelect() {
    var _a, _b;
    const alert = getAlert($variant) || ((_a = $variant.closest(".custom-select")) == null ? void 0 : _a.querySelector(".custom-select__error"));
    const value = (_b = $variant == null ? void 0 : $variant.value) == null ? void 0 : _b.trim();
    if (!value) {
      setError($variant, alert, "Please choose an amount.");
      return false;
    }
    clearError($variant, alert);
    return true;
  }
  function validateName() {
    const alert = getAlert($name);
    const value = $name.value.trim();
    if (!value) {
      setError($name, alert, "Please enter the recipient's name.");
      return false;
    }
    if (!noteRegex.test(value)) {
      setError($name, alert, "Invalid characters in name.");
      return false;
    }
    clearError($name, alert);
    return true;
  }
  function validateEmail() {
    const alert = getAlert($email);
    const value = $email.value.trim();
    if (!value) {
      setError($email, alert, "Please enter recipient's email.");
      return false;
    }
    if (!emailRegex.test(value)) {
      setError($email, alert, "Please enter a valid email address.");
      return false;
    }
    clearError($email, alert);
    return true;
  }
  function validateDate() {
    const alert = getAlert($date);
    const value = $date.value.trim();
    if (!value) {
      setError($date, alert, "Please enter a delivery date.");
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);
    const selected = new Date(year, month - 1, day);
    const today = /* @__PURE__ */ new Date();
    today.setHours(0, 0, 0, 0);
    const maxDate = new Date(today);
    maxDate.setDate(today.getDate() + 30);
    if (selected < today) {
      setError($date, alert, "Delivery date cannot be in the past.");
      return false;
    }
    if (selected > maxDate) {
      setError($date, alert, "Delivery date cannot be more than 30 days from today.");
      return false;
    }
    clearError($date, alert);
    return true;
  }
  function validateTime() {
    var _a, _b;
    const $time2 = form.querySelector("#delivery-time");
    const alert = getAlert($time2) || ((_a = $time2 == null ? void 0 : $time2.closest(".is-select")) == null ? void 0 : _a.querySelector(".alert"));
    const value = (_b = $time2 == null ? void 0 : $time2.value) == null ? void 0 : _b.trim();
    if (!value) {
      setError($time2, alert, "Please choose a time.");
      return false;
    }
    clearError($time2, alert);
    return true;
  }
  function validateNote() {
    const alert = getAlert($note);
    const value = $note.value.trim();
    if (value && !noteRegex.test(value)) {
      setError($note, alert, "Invalid characters in the note.");
      return false;
    }
    clearError($note, alert);
    return true;
  }
  function validateForm() {
    const validations = [
      validateVariantSelect,
      validateName,
      validateEmail,
      validateDate,
      validateTime,
      validateNote
    ];
    return validations.every((fn) => fn());
  }
  const inputs = [$variant, $name, $email, $note, $date, $time];
  inputs.forEach((el) => {
    const eventType = el.tagName === "SELECT" || el.type === "date" ? "change" : "input";
    el.addEventListener(eventType, () => {
      switch (el) {
        case $variant:
          validateVariantSelect();
          break;
        case $name:
          validateName();
          break;
        case $email:
          validateEmail();
          break;
        case $note:
          validateNote();
          break;
        case $date:
          validateDate();
          break;
        case $time:
          validateTime();
          break;
      }
    });
  });
  const isValid = validateForm();
  if (!isValid) {
    const firstError = form.querySelector(".border-red-100");
    if (firstError) {
      firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      firstError.focus({ preventScroll: true });
    }
  }
  return isValid;
}
let isSubmittingAddToBag = false;
function initAddToBag(cartInstance2, root = document) {
  const container = root;
  cartInstance2.cart = new JKCart();
  container.addEventListener("click", async (e) => {
    var _a;
    let btn = e.target.closest(".js-add-to-bag");
    if (!btn) {
      btn = e.target.closest(".js-edit-cart-item");
    }
    if (!btn) return;
    const productContainer = btn == null ? void 0 : btn.closest(".main-product");
    const variantSelect = productContainer.querySelector(".js-hidden-id");
    const selectedValue = variantSelect == null ? void 0 : variantSelect.value;
    e.preventDefault();
    e.stopPropagation();
    if (!validateOptionSelected(productContainer)) return;
    if (!selectedValue || isSubmittingAddToBag) return;
    const $giftcardForm = productContainer.querySelector("#giftcardForm");
    if ($giftcardForm && !giftcardFormIsValid(document)) return;
    isSubmittingAddToBag = true;
    let jsAddToBagElement = btn.querySelector(".js-add-to-bag-text");
    _JK.helpers.removeClass(btn, "bg-charcoal-100");
    _JK.helpers.removeClass(btn, "hover:bg-charcoal-130");
    _JK.helpers.addClass(btn, "bg-charcoal-80");
    let jsAddToBagOriginalText = jsAddToBagElement.innerHTML;
    jsAddToBagElement.innerHTML = "Adding...";
    const variantId = parseInt(selectedValue, 10);
    const quantityInput = productContainer.querySelector(".js-input-qty");
    let quantity = parseInt((quantityInput == null ? void 0 : quantityInput.value) || "1", 10);
    _JK.Bag.lastQuantity = quantity;
    const vid = parseInt((_a = btn == null ? void 0 : btn.dataset) == null ? void 0 : _a.id, 0);
    const propertyInputs = productContainer.querySelectorAll('[name^="properties["]');
    let properties = {};
    propertyInputs.forEach((input) => {
      let nameMatch = input.name.match(/^properties\[(.+)\]$/);
      if (!nameMatch) return;
      let key = nameMatch[1];
      if (input.type === "checkbox") {
        if (input.checked) {
          properties[key] = input.value || "Yes";
        }
      } else if (input.type === "radio") {
        if (input.checked) {
          properties[key] = input.value;
        }
      } else {
        if (input.value) {
          properties[key] = input.value;
        }
      }
    });
    try {
      const isEditMode = btn.classList.contains("js-edit-cart-item");
      const cart2 = await cartInstance2.cart.fetchCart();
      if (isEditMode) {
        const existingItem = cart2.items.find((item) => item.id === variantId);
        if (existingItem) {
          const existingQty = existingItem.quantity;
          if (existingItem.id && existingItem.id != vid) {
            await cartInstance2.cart.removeItem(vid);
            quantity = quantity + existingQty;
          }
          await cartInstance2.cart.updateItem(existingItem.id, quantity);
        } else {
          const updatedItem = cart2.items.find((item) => item.id === vid);
          if (updatedItem) {
            await cartInstance2.cart.removeItem(vid);
          }
          cartInstance2.cart.addItem(variantId, quantity, properties).then(() => {
            var _a2;
            cartInstance2.sections = [
              "cart-empty-msg",
              "cart-items",
              "cart-important-notes",
              "cart-free-shipping-promo",
              "cart-order-summary"
            ];
            if (((_a2 = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a2.template) == "cart") {
              cartInstance2.renderCart();
              cartInstance2.isCartPage = true;
            } else {
              cartInstance2.openDrawer();
            }
          });
        }
      } else {
        cartInstance2.cart.addItem(variantId, quantity, properties).then(() => {
          var _a2;
          cartInstance2.sections = [
            "cart-empty-msg",
            "cart-items",
            "cart-important-notes",
            "cart-free-shipping-promo",
            "cart-order-summary"
          ];
          if (((_a2 = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a2.template) == "cart") {
            cartInstance2.cartPage.querySelector(".cart__empty-wrapper").innerHTML = "";
            cartInstance2.renderCart();
            cartInstance2.isCartPage = true;
          } else {
            cartInstance2.openDrawer();
          }
        });
      }
    } catch (error) {
      console.error("Add to cart failed:", error);
    } finally {
      setTimeout(() => {
        root.querySelectorAll(".shopify-product-form .js-input-qty").forEach((input) => input.value = 1);
        root.querySelectorAll(".shopify-product-form .js-text-qty").forEach((el) => el.innerText = 1);
        isSubmittingAddToBag = false;
        jsAddToBagElement.innerHTML = jsAddToBagOriginalText;
        _JK.helpers.removeClass(btn, "bg-charcoal-80");
        _JK.helpers.addClass(btn, "bg-charcoal-100");
        _JK.helpers.addClass(btn, "hover:bg-charcoal-130");
      }, 1300);
    }
  });
}
class CartComponent {
  constructor(root = document) {
    this.cartModeType = root;
    this.isUpdatingCart = false;
    this.importantNotesShopliftDecision = null;
    this.importantNotesShopliftInFlight = null;
    this.refreshElementRefs();
    this.refreshModalRefs();
    this.handleModalShown = this.handleModalShown.bind(this);
    this.boundHandlers = /* @__PURE__ */ new Map();
    this.cartTrigger = document.getElementById("openDrawerBtn");
  }
  refreshModalRefs() {
    var _a, _b, _c, _d, _e;
    this.initRemoveItemModalDOM = ((_a = this.cartModeType) == null ? void 0 : _a.querySelector(".modal-cart")) || ((_b = this.cartModeType) == null ? void 0 : _b.querySelector(".modal-cart-page"));
    this.editItemModalDOM = (_c = this.cartModeType) == null ? void 0 : _c.querySelector(".modal-quick-edit-cart");
    this.editConfirmationModalDOM = (_d = this.cartModeType) == null ? void 0 : _d.querySelector(".modal-confirmation-edit-cart");
    this.quickEditComponent = (_e = this.editItemModalDOM) == null ? void 0 : _e.querySelector(".edit-cart__component");
  }
  refreshElementRefs() {
    this.elements = {
      cartDrawer: this.cartModeType.getElementById("cartDrawer"),
      cartPage: document.getElementById("cartPage"),
      // still global
      backdrop: this.cartModeType.getElementById("backdrop"),
      productList: this.cartModeType.getElementById("productList"),
      subtotal: this.cartModeType.getElementById("subtotal"),
      total: this.cartModeType.querySelectorAll(".cart-total"),
      totalDiscount: this.cartModeType.getElementById("total-discount"),
      openDrawerBtn: this.cartModeType.getElementById("openDrawerBtn"),
      closeDrawerBtn: this.cartModeType.getElementById("closeDrawerBtn"),
      continueShoppingBtn: this.cartModeType.getElementById("continueShoppingBtn"),
      itemCounterElements: this.cartModeType.querySelectorAll(".item-counter"),
      addModal: document.querySelector("#universal-modal-add-to-bag")
    };
    Object.entries(this.elements).forEach(([key, el]) => {
      this[key] = el;
    });
  }
  init() {
    var _a, _b, _c, _d;
    const ShopifyTemplate = ((_a = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a.template) || "";
    this.isCartPage = ShopifyTemplate === "cart";
    if (this.cartDrawer) {
      (_b = this.openDrawerBtn) == null ? void 0 : _b.addEventListener("click", (e) => this.openDrawer(e));
      (_c = this.closeDrawerBtn) == null ? void 0 : _c.addEventListener("click", this.closeDrawer.bind(this));
      (_d = this.cartDrawer) == null ? void 0 : _d.addEventListener("click", (e) => {
        if (!e.target.closest(".main-dialog")) {
          this.closeDrawer();
        }
      });
    }
    this.cart = new JKCart();
    this.sections = [
      "cart-empty-msg",
      "cart-items",
      "cart-important-notes",
      "cart-free-shipping-promo",
      "cart-order-summary"
    ];
    if (!this.isCartPage) {
      this.renderCart();
    } else {
      const cartObject = this.cartPage;
      this.bindEvents(cartObject);
      this.applyImportantNotesShopliftTest(cartObject);
    }
    ["jkCart:updated-item", "jkCart:added-item"].forEach((eventType) => {
      window.addEventListener(eventType, this.renderCartItems.bind(this));
    });
  }
  openDrawer(e = null) {
    var _a, _b, _c, _d;
    if (e && typeof e.stopPropagation === "function") {
      e.stopPropagation();
    }
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    (_a = this.backdrop) == null ? void 0 : _a.classList.add("opacity-100");
    (_b = this.backdrop) == null ? void 0 : _b.classList.remove("opacity-0", "pointer-events-none");
    this.renderCart();
    (_c = this.cartDrawer) == null ? void 0 : _c.classList.remove("translate-x-full");
    document.body.classList.add("overflow-hidden", "ui-active");
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    (_d = this.cartTrigger) == null ? void 0 : _d.setAttribute("aria-expanded", "true");
  }
  getImportantNotesConfig(cartObject) {
    var _a, _b, _c;
    const wrapper = cartObject == null ? void 0 : cartObject.querySelector(".cart__notes-wrapper");
    const note = wrapper == null ? void 0 : wrapper.querySelector("[data-cart-important-notes]");
    return {
      wrapper,
      note,
      enabled: ((_a = note == null ? void 0 : note.dataset) == null ? void 0 : _a.slVisibilityTest) === "true",
      hypothesisId: (_c = (_b = note == null ? void 0 : note.dataset) == null ? void 0 : _b.slHideHypothesisId) == null ? void 0 : _c.trim()
    };
  }
  shouldEvaluateImportantNotes(cartObject) {
    var _a;
    const { wrapper, note, enabled, hypothesisId } = this.getImportantNotesConfig(cartObject);
    if (!wrapper || !note || !enabled || !hypothesisId) return false;
    const noteText = ((_a = note.textContent) == null ? void 0 : _a.trim()) || "";
    return noteText.length > 0 && note.offsetParent !== null;
  }
  async resolveImportantNotesShopliftDecision(cartObject) {
    if (typeof this.importantNotesShopliftDecision === "boolean") {
      return this.importantNotesShopliftDecision;
    }
    if (this.importantNotesShopliftInFlight) {
      return this.importantNotesShopliftInFlight;
    }
    const { enabled, hypothesisId } = this.getImportantNotesConfig(cartObject);
    if (!enabled || !hypothesisId) {
      this.importantNotesShopliftDecision = true;
      return this.importantNotesShopliftDecision;
    }
    const shoplift = window.shoplift;
    if (!shoplift || typeof shoplift.isHypothesisActive !== "function") {
      this.importantNotesShopliftDecision = true;
      return this.importantNotesShopliftDecision;
    }
    this.importantNotesShopliftInFlight = shoplift.isHypothesisActive(hypothesisId).then((shouldHide) => {
      this.importantNotesShopliftDecision = !shouldHide;
      return this.importantNotesShopliftDecision;
    }).catch((error) => {
      console.warn("Important notes Shoplift test failed:", error);
      this.importantNotesShopliftDecision = true;
      return this.importantNotesShopliftDecision;
    }).finally(() => {
      this.importantNotesShopliftInFlight = null;
    });
    return this.importantNotesShopliftInFlight;
  }
  async applyImportantNotesShopliftTest(cartObject) {
    if (!this.shouldEvaluateImportantNotes(cartObject)) return;
    const shouldShowImportantNotes = await this.resolveImportantNotesShopliftDecision(cartObject);
    const { wrapper } = this.getImportantNotesConfig(cartObject);
    if (!wrapper) return;
    wrapper.classList.toggle("hidden", !shouldShowImportantNotes);
  }
  closeDrawer() {
    var _a, _b;
    this.backdrop.classList.remove("opacity-100");
    this.backdrop.classList.add("opacity-0", "pointer-events-none");
    (_a = this.cartDrawer) == null ? void 0 : _a.classList.add("translate-x-full");
    _JK.helpers.removeClass(document.body, "overflow-hidden", "ui-active");
    document.body.style.paddingRight = "";
    (_b = this.cartTrigger) == null ? void 0 : _b.setAttribute("aria-expanded", "false");
  }
  updateCartQuantity(lineItemId, newQuantity, cartObject) {
    if (this.isUpdatingCart) return;
    if (newQuantity < 1) {
      this.confirmRemove(lineItemId, cartObject);
      return;
    }
    if (newQuantity > 100) newQuantity = 100;
    this.isUpdatingCart = true;
    const cartItemWrapper = this.cartModeType.querySelector("#cart-item-wrapper");
    const cartItemListWrapper = cartItemWrapper.querySelector(`li[data-item-id="${lineItemId}"]`);
    cartItemListWrapper == null ? void 0 : cartItemListWrapper.classList.add("opacity-50");
    cartItemListWrapper == null ? void 0 : cartItemListWrapper.classList.remove("opacity-100");
    const qtyElement = this.cartModeType.querySelector(`#quantity-${lineItemId}`);
    if (qtyElement) qtyElement.value = newQuantity;
    this.cart.updateItem(lineItemId, newQuantity).then().catch((error) => console.error("Error updating cart:", error)).finally(() => {
      this.isUpdatingCart = false;
    });
  }
  bindEvents(cartObject) {
    var _a;
    this.unbindEvents();
    const setupButtons = (prefix, handler, eventType = "click") => {
      cartObject.querySelectorAll(`[id^="${prefix}-"]`).forEach((button) => {
        const listener = (e) => {
          e.stopPropagation();
          e.preventDefault();
          const lineItemId = e.currentTarget.id.replace(`${prefix}-`, "");
          handler(lineItemId, e);
        };
        button.addEventListener(eventType, listener);
        this.boundHandlers.set(button, (this.boundHandlers.get(button) || []).concat([[eventType, listener]]));
      });
    };
    setupButtons("decrement", (id) => {
      var _a2;
      if (this.isUpdatingCart) return;
      const qty = parseInt(((_a2 = cartObject.querySelector(`#quantity-${id}`)) == null ? void 0 : _a2.value) || "1", 10);
      if (qty > 1) this.updateCartQuantity(id, qty - 1, cartObject);
    });
    setupButtons("increment", (id) => {
      var _a2;
      if (this.isUpdatingCart) return;
      const qty = parseInt(((_a2 = cartObject.querySelector(`#quantity-${id}`)) == null ? void 0 : _a2.value) || "0", 10);
      if (qty < 100) this.updateCartQuantity(id, qty + 1, cartObject);
    });
    setupButtons("remove", (id) => this.confirmRemove(id, cartObject));
    setupButtons("quantity", (id, e) => this.inputChange(id, e, cartObject), "change");
    const modals = {
      remove: {
        refKey: "initRemoveItemModal",
        selector: ".modal-cart",
        openBtn: ".open-modal",
        closeBtn: "#close-cart-modal"
      },
      edit: {
        refKey: "initEditItemModal",
        selector: ".modal-quick-edit-cart",
        openBtn: ".open-edit-item-modal",
        closeBtn: "#close-edit-cart-modal"
      },
      confirmEdit: {
        refKey: "initEditCartConfirmModal",
        selector: ".modal-confirmation-edit-cart",
        openBtn: ".open-confirmation-edit-cart-modal",
        closeBtn: "#close-confirmation-edit-cart-modal"
      }
    };
    for (const [key, { refKey, selector, openBtn, closeBtn }] of Object.entries(modals)) {
      const modalInstance = this[refKey];
      if (modalInstance && typeof modalInstance.refresh === "function") {
        modalInstance.refresh(this.cartModeType);
      } else {
        this.initItemModal(key, selector, openBtn, closeBtn);
      }
    }
    window.addEventListener("resize", this.onResize);
    if ((_a = _JK == null ? void 0 : _JK.GWP) == null ? void 0 : _a.active) {
      window.dispatchEvent(new CustomEvent("jkCart:bindEvents"));
    }
  }
  unbindEvents() {
    for (const [el, handlers] of this.boundHandlers.entries()) {
      handlers.forEach(([eventType, handler]) => {
        el.removeEventListener(eventType, handler);
      });
    }
    this.boundHandlers.clear();
    window.removeEventListener("resize", this.onResize);
  }
  async handleModalShown(e, el = null) {
    var _a, _b, _c, _d, _e, _f, _g;
    this.key = ((_a = e.detail) == null ? void 0 : _a.itemKey) || e.itemKey;
    if (((_b = e.detail) == null ? void 0 : _b.lineItemId) || e.lineItemId) {
      this.lineItemId = ((_c = e.detail) == null ? void 0 : _c.lineItemId) || e.lineItemId;
    }
    this.handle = ((_d = e.detail) == null ? void 0 : _d.handle) || e.handle;
    if (!this.handle) return console.warn("No product handle provided in modal:shown event.");
    try {
      const res = await fetch(`/products/${this.handle}?sections=redesign-main-product&view=redesign-quickview`, {
        headers: { "Accept": "text/html" }
      });
      const data = await res.json();
      let activeSize;
      if (el) {
        activeSize = (_g = (_f = (_e = el.closest(".product-essentials--wrapper")) == null ? void 0 : _e.querySelector("form")) == null ? void 0 : _f.querySelector('input[name="options[Size]"]:checked')) == null ? void 0 : _g.value;
      }
      this.renderEditCart(data["redesign-main-product"], activeSize);
    } catch (err) {
      console.error("Failed to load quickview product:", err);
    }
  }
  inputChange(lineItemId, event, cartObject) {
    const newQuantity = parseInt(event.currentTarget.value, 10);
    if (!isNaN(newQuantity) && newQuantity <= 99) {
      this.updateCartQuantity(lineItemId, newQuantity, cartObject);
    }
  }
  confirmRemove(lineItemId, cartObject) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
    const item = cartObject.querySelector(`[data-item-id="${lineItemId}"]`);
    if (!item) return;
    const qtyElement = this.cartModeType.querySelector(`#quantity-${lineItemId}`);
    this.previousQuantityLineItemId = lineItemId;
    this.previousQuantityValue = qtyElement ? parseInt(qtyElement.value, 10) || 1 : 1;
    const modalContent = `
      <p class="text-charcoal-100 redesign-body-4 mx-32 mt-32 mb-16">Do you wish to remove this product<br/>from your cart?</p>
      <ul class="px-32 py-16"><li class="flex gap-16">${item.innerHTML}</li></ul>
      </div>`;
    const component = (_a = this.initRemoveItemModalDOM) == null ? void 0 : _a.querySelector(".cart__item-component");
    if (component) component.innerHTML = modalContent;
    (_b = this.initRemoveItemModalDOM) == null ? void 0 : _b.setAttribute("data-item-id", lineItemId);
    (_d = (_c = this.initRemoveItemModalDOM) == null ? void 0 : _c.querySelector(".item__total")) == null ? void 0 : _d.remove();
    (_f = (_e = this.initRemoveItemModalDOM) == null ? void 0 : _e.querySelector(".item__quantity-wrapper")) == null ? void 0 : _f.remove();
    (_h = (_g = this.initRemoveItemModalDOM) == null ? void 0 : _g.querySelector(".item__actions-wrapper")) == null ? void 0 : _h.remove();
    const actions = (_i = this.initRemoveItemModalDOM) == null ? void 0 : _i.querySelector(".modal-actions");
    (_k = (_j = this.initRemoveItemModalDOM) == null ? void 0 : _j.querySelectorAll(".js-cancel-remove-action")) == null ? void 0 : _k.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.initRemoveItemModal.close();
        this.initRemoveItemModalDOM.removeAttribute("data-item-id");
        component.innerHTML = "";
        const qtyElement2 = this.cartModeType.querySelector(`#quantity-${this.previousQuantityLineItemId}`);
        if (qtyElement2) {
          qtyElement2.value = this.previousQuantityValue;
        }
      });
    });
    (_l = this.initRemoveItemModalDOM) == null ? void 0 : _l.addEventListener("modal:closed", () => {
      this.cartModeType.querySelector(`#remove-${this.previousQuantityLineItemId}`).setAttribute("aria-expanded", false);
    });
    const removeBtn = actions == null ? void 0 : actions.querySelector("#removeCartItem");
    if (removeBtn) {
      const newRemoveBtn = removeBtn.cloneNode(true);
      removeBtn.replaceWith(newRemoveBtn);
      newRemoveBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.cart.removeItem(lineItemId).then(() => {
          const GWP = _JK == null ? void 0 : _JK.GWP;
          if ((GWP == null ? void 0 : GWP.active) && GWP.autoOrManual === "auto" && lineItemId === String(GWP.autoAddVariantId)) {
            SDG.setCookie(GWP.cookieName, "true", GWP.cookieHours, "hours");
          }
          if (cartObject.querySelectorAll(".cart__item").length === 1) {
            this.cart.fetchSections(["cart-empty-msg"]).then((data) => {
              [".cart__drawer-header > h2", ".cart__drawer-actions", "#cart-heading"].forEach((sel) => {
                var _a2;
                (_a2 = cartObject.querySelector(sel)) == null ? void 0 : _a2.classList.add("invisible");
              });
              [".order__summary-wrapper", ".cart__items-wrapper", ".cart__notes-wrapper", ".cart__promo-wrapper"].forEach((sel) => {
                var _a2;
                return (_a2 = cartObject.querySelector(sel)) == null ? void 0 : _a2.replaceChildren();
              });
              const emptyWrapper = cartObject.querySelector(".cart__empty-wrapper");
              if (emptyWrapper) {
                emptyWrapper.classList.remove("hidden");
                emptyWrapper.innerHTML = data["cart-empty-msg"];
              }
            });
            const rewardBanner = cartObject.querySelector("#shopify-section-cart-rewards-banner");
            if (rewardBanner) {
              rewardBanner.innerHTML = ``;
            }
            const gwpWrapper = cartObject.querySelector(".cart__gwp-wrapper");
            if (gwpWrapper) {
              gwpWrapper.innerHTML = "";
            }
          } else {
            this.renderCart();
          }
          this.initRemoveItemModal.close();
          this.initRemoveItemModalDOM.removeAttribute("data-item-id");
          component.innerHTML = "";
        }).catch((e2) => console.error("Error removing cart item:", e2));
      });
    }
    (_m = this.initRemoveItemModal) == null ? void 0 : _m.open();
  }
  initItemModal(type, modalSelector, openSelector, closeSelector) {
    setTimeout(() => {
      var _a, _b, _c, _d, _e;
      const modalEl = this.cartModeType.querySelector(modalSelector);
      if (!modalEl) {
        console.warn(`[UniversalModal] Modal ${modalSelector} not found. Delaying init.`);
        return;
      }
      const modalMap = {
        remove: "initRemoveItemModal",
        edit: "initEditItemModal",
        confirmEdit: "initEditCartConfirmModal"
      };
      const modalKey = modalMap[type];
      if (!modalKey) {
        console.warn(`Unknown modal type: ${type}`);
        return;
      }
      if ((_a = this[modalKey]) == null ? void 0 : _a.destroy) {
        this[modalKey].destroy();
      }
      const modal = new UniversalModal(modalSelector, openSelector, closeSelector, this.cartModeType, true);
      this[modalKey] = modal;
      if (type === "edit") {
        (_b = this.editItemModalDOM) == null ? void 0 : _b.removeEventListener("modal:shown", this.handleModalShown);
        this.editItemModalDOM = this.cartModeType.querySelector(modalSelector);
        (_c = this.editItemModalDOM) == null ? void 0 : _c.addEventListener("modal:shown", this.handleModalShown.bind(this));
      }
      if (type === "confirmEdit") {
        (_d = this.editConfirmationModalDOM) == null ? void 0 : _d.removeEventListener("modal:shown", this.renderEditConfirmation);
        this.editConfirmationModalDOM = this.cartModeType.querySelector(modalSelector);
        (_e = this.editConfirmationModalDOM) == null ? void 0 : _e.addEventListener("modal:shown", this.renderEditConfirmation.bind(this));
      }
    }, 0);
  }
  setupSwatchHandler() {
    const swatchLists = this.quickEditComponent.querySelectorAll(".swatch--colors");
    if (!swatchLists.length) return;
    if (this._boundSwatchClick) {
      swatchLists.forEach((list) => {
        list.removeEventListener("click", this._boundSwatchClick);
      });
    }
    this._boundSwatchClick = (e) => {
      e.preventDefault();
      const el = e.target.closest(".swatch--link");
      if (el) {
        this.handleModalShown(el.dataset, el);
      }
    };
    swatchLists.forEach((list) => {
      list.addEventListener("click", this._boundSwatchClick);
    });
  }
  renderEditConfirmation(e) {
    var _a;
    const quickEditConfirmationWrapper = (_a = e.target) == null ? void 0 : _a.querySelector(".confirmation-edit-cart__component");
    if (quickEditConfirmationWrapper) {
      quickEditConfirmationWrapper.innerHTML = `<div class="redesign-body-4">Your item was updated.</div>`;
    }
  }
  getOptionsListFromItem(item) {
    if (!item.options_with_values || !Array.isArray(item.options_with_values)) return "";
    return item.options_with_values.map((opt) => opt.value).join(", ");
  }
  renderCartItems(e) {
    var _a, _b, _c, _d;
    if ((_a = this.initEditItemModal) == null ? void 0 : _a.isOpen) {
      (_b = this.initEditItemModal) == null ? void 0 : _b.close();
      (_c = this.initEditCartConfirmModal) == null ? void 0 : _c.open();
      setTimeout(() => {
        this.renderCart();
      }, 300);
    } else {
      this.unbindEvents();
      const lineItemId = (_d = e == null ? void 0 : e.detail) == null ? void 0 : _d.lineItemId;
      const cartSections = [
        "cart-items",
        "cart-free-shipping-promo",
        "cart-order-summary"
      ];
      const template = this.isCartPage ? "cart" : "redesign-cart-drawer";
      this.cart.fetchSections(cartSections, template).then((data) => {
        var _a2;
        const cartObject = this.cartPage || this.cartDrawer;
        if (!cartObject) return;
        const updates = [
          { selector: "#cart-heading", content: null, removeInvisible: cart.item_count > 0 ? true : false },
          { selector: ".cart__promo-wrapper", content: data["cart-free-shipping-promo"] },
          { selector: ".order__summary-wrapper", content: data["cart-order-summary"] }
        ];
        updates.forEach(({ selector, content, removeInvisible }) => {
          const el = cartObject.querySelector(selector);
          if (el) {
            if (removeInvisible) el.classList.remove("invisible");
            if (content !== null) {
              el.innerHTML = content;
            }
          }
        });
        const cartItemWrapperDOM = cartObject.querySelector(".cart__items-wrapper");
        const parser = new DOMParser();
        const cartItemsDOM = parser.parseFromString(data["cart-items"], "text/html");
        const cartItemWrapper = cartItemsDOM.querySelector("#cart-item-wrapper");
        const cartItemUpdated = cartItemWrapper == null ? void 0 : cartItemWrapper.querySelector(`li[data-item-id="${lineItemId}"]`);
        const existingItem = cartItemWrapperDOM == null ? void 0 : cartItemWrapperDOM.querySelector(`li[data-item-id="${lineItemId}"]`);
        if (existingItem && cartItemUpdated) {
          const itemDesc = cartItemUpdated.querySelector(".cart-item--description");
          const itemPrice = cartItemUpdated.querySelector(".item__total");
          existingItem == null ? void 0 : existingItem.classList.add("opacity-100");
          existingItem == null ? void 0 : existingItem.classList.remove("opacity-50");
          existingItem == null ? void 0 : existingItem.querySelector(".cart-item--description").replaceWith(itemDesc);
          existingItem == null ? void 0 : existingItem.querySelector(".item__total").replaceWith(itemPrice);
        }
        const cartItemTotal = ((_a2 = cartItemWrapper == null ? void 0 : cartItemWrapper.dataset) == null ? void 0 : _a2.cartItemTotal) ?? 0;
        this.cartModeType.querySelectorAll(".js-cart-count").forEach((el) => {
          el.innerHTML = cartItemTotal;
          _JK.Bag.item_count = cartItemTotal;
        });
        this.bindEvents(cartObject);
        this.applyImportantNotesShopliftTest(cartObject);
        lazyLoadImages(this.cartModeType);
      });
    }
  }
  async renderEditCart(sectionHTML, activeSize = "") {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!this.quickEditComponent) return;
    sectionHTML = sectionHTML.replace(/{width}/g, () => "28");
    sectionHTML = sectionHTML.replace(/lazyload/g, (match) => {
      if (match.startsWith("lazyload")) return "custom__lazy";
    });
    this.quickEditComponent.innerHTML = sectionHTML;
    const section = (_a = this.quickEditComponent) == null ? void 0 : _a.querySelector("#shopify-section-redesign-main-product");
    section == null ? void 0 : section.classList.remove("mt-50");
    section == null ? void 0 : section.classList.add("lg:py-28", "lg:pl-28", "lg:pr-32");
    const modalTitle = document.createElement("span");
    modalTitle.innerText = "Edit Item:";
    modalTitle.classList.add("redesign-body-5");
    const navHandler = (_b = this.quickEditComponent) == null ? void 0 : _b.querySelector(".heading-wrapper-mobile");
    if (navHandler) {
      navHandler.classList.remove("pt-28", "pb-24", "p-0", "px-20");
      navHandler.classList.add("py-18", "px-28", "top-0", "sticky", "z-101", "bg-ivory", "rounded-[10px_10px_0px_0px]");
      navHandler.innerHTML = "";
      navHandler.appendChild(modalTitle);
    }
    const productForm = this.quickEditComponent.querySelector("#addToBagForm");
    productForm.setAttribute("id", "addEditBagForm");
    const productContainer = (_c = this.quickEditComponent) == null ? void 0 : _c.querySelector("#product");
    productContainer.setAttribute("id", "editview-product");
    if (productContainer) {
      productContainer.classList.remove("lg:gap-100");
      productContainer.classList.add("lg:gap-32", "overflow-y-auto", "max-h-screen");
    }
    const essentials = (_d = this.quickEditComponent) == null ? void 0 : _d.querySelector(".redesign-product-essentials");
    if (essentials) {
      essentials == null ? void 0 : essentials.classList.remove("lg:mr-100", "lg:pt-80", "px-20");
      essentials == null ? void 0 : essentials.classList.add("px-28", "lg:pt-0", "pt-24", "lg:pb-0", "pb-85");
    }
    const navDesktopHandler = essentials.querySelector(".heading-wrapper-desktop");
    if (navDesktopHandler) {
      (_e = navDesktopHandler.querySelector("h1")) == null ? void 0 : _e.classList.remove("mt-12", "mb-8");
      (_f = navDesktopHandler.querySelector("h1")) == null ? void 0 : _f.classList.add("lg:w-full", "w-[65%]");
      navDesktopHandler.classList.remove("pt-28", "pb-24", "px-20", "hidden");
      navDesktopHandler.classList.add("lg:pt-0", "pt-0", "pb-8", "px-0", "relative");
    }
    const productFormWrapper = essentials.querySelector(".product-form--wrapper");
    if (productFormWrapper) {
      productFormWrapper == null ? void 0 : productFormWrapper.classList.remove("pb-12");
      const qtyWrapper = productFormWrapper.querySelector(".item__quantity-wrapper");
      qtyWrapper == null ? void 0 : qtyWrapper.classList.remove("mb-40");
      qtyWrapper == null ? void 0 : qtyWrapper.classList.add("mb-10");
      productFormWrapper.querySelector("#btnAddToBagText").innerHTML = "Update Item";
    }
    this.quickEditComponent.classList.remove("hidden");
    this.setupSwatchHandler();
    const sourceInput = ((_g = this.cartDrawer) == null ? void 0 : _g.querySelector(`#quantity-${this.lineItemId}`)) || ((_h = this.cartPage) == null ? void 0 : _h.querySelector(`#quantity-${this.lineItemId}`));
    const targetInput = this.quickEditComponent.querySelector("#quantity-redesign-main-product");
    if (sourceInput && targetInput) {
      targetInput.value = sourceInput.value;
    }
    const $productForm = this.quickEditComponent.querySelector("#addEditBagForm");
    const $productSection = this.quickEditComponent.querySelector("#editview-product");
    productSwatches(this.cartModeType);
    productQty($productSection, $productForm);
    lazyLoadImages(this.quickEditComponent);
    if (!$productForm || !$productSection) {
      console.warn("Product form or section not found. Skipping configurable initialization.");
      return;
    }
    $productForm.querySelectorAll(".js-option").forEach((jsOption, index) => {
      const optionInput = jsOption.querySelector("input");
      const optionlabel = jsOption.querySelector("label");
      const optionNewId = optionInput.getAttribute("id") + "-" + index;
      optionInput.setAttribute("id", `${optionNewId}`);
      optionlabel.setAttribute("for", `${optionNewId}`);
    });
    const productConfigurables = new ProductConfigurables({
      productForm: $productForm,
      productSection: $productSection,
      quickview: true
    }, this.cartModeType);
    productConfigurables.init();
    const galleryWrapper = this.quickEditComponent.querySelector(".product-image--gallery");
    galleryWrapper == null ? void 0 : galleryWrapper.classList.remove("mb-24");
    const gallery = this.quickEditComponent.querySelector("#gallery-carousel-mini-pdp");
    gallery == null ? void 0 : gallery.classList.remove("mb-4");
    gallery.setAttribute("id", "gallery-carousel-edit-cart");
    if (gallery) {
      gallery.classList.remove("hidden");
      const galleryEditCartEl = this.quickEditComponent.querySelector("#gallery-carousel-edit-cart");
      new ProductGallery(galleryEditCartEl, "", 1023, {
        useThumbs: false,
        thumbsOn: "none",
        splideOptions: {
          type: "slide",
          perPage: 1,
          pagination: false,
          arrows: true,
          heightRatio: 1,
          cover: true,
          keyboard: "global",
          focus: "left",
          breakpoints: {
            1023: {
              drag: true,
              heightRatio: 0.78,
              autoHeight: true,
              perPage: 1.54,
              perMove: 1,
              arrows: false
            }
          }
        }
      }, true);
    }
    const addTobag = this.quickEditComponent.querySelector("#btnAddToBag");
    addTobag.setAttribute("data-id", this.lineItemId);
    const addTobagWrapper = addTobag.closest(".js-add-to-bag-wrapper");
    addTobagWrapper == null ? void 0 : addTobagWrapper.classList.remove("mt-40");
    addTobagWrapper == null ? void 0 : addTobagWrapper.classList.add("mt-28");
    addTobag == null ? void 0 : addTobag.classList.remove("js-add-to-bag");
    addTobag == null ? void 0 : addTobag.classList.add("js-edit-cart-item");
    const liItem = this.quickEditComponent.querySelector(`li[data-variant-id="${this.lineItemId}"]`);
    liItem == null ? void 0 : liItem.classList.add("is-active");
    const swatchInput = this.quickEditComponent.querySelector(`input[data-variant-id="${this.lineItemId}"]`);
    if (swatchInput) {
      this.quickEditComponent.querySelector(".js-config-current-size").innerText = swatchInput.value;
      swatchInput.setAttribute("checked", true);
    }
    initAddToBag(this, this.cartModeType);
    if (productForm) {
      const input = $productForm.querySelector(`input[name="options[Size]"][value="${activeSize}"]`) || $productForm.querySelector(`input[name="options[Size]"]:checked`);
      if (input) {
        input.checked = true;
        const selectedSize = activeSize == "" ? input.value : activeSize;
        (async () => {
          const productHandle = $productSection.dataset.handle;
          productConfigurables.product = await productConfigurables.getProductJson(productHandle);
          const optionsLength = productConfigurables.product.options[0].values.length;
          productConfigurables.updateSwatchAvailability(selectedSize, optionsLength);
        })();
      }
    }
  }
  renderCart() {
    var _a;
    const cartItemWrapper = (_a = this.cartModeType) == null ? void 0 : _a.querySelector("#cart-item-wrapper");
    cartItemWrapper == null ? void 0 : cartItemWrapper.classList.add("opacity-50");
    cartItemWrapper == null ? void 0 : cartItemWrapper.classList.remove("opacity-100");
    this.cart.fetchCart().then((cart2) => {
      const template = this.isCartPage ? "cart" : "redesign-cart-drawer";
      this.cart.fetchSections(this.sections, template).then((data) => {
        var _a2, _b, _c, _d;
        const cartObject = this.cartPage || this.cartDrawer;
        if (!cartObject) return;
        const hasItems = cart2.item_count > 0;
        const updates = [
          { selector: ".cart__drawer-actions", content: null, removeInvisible: hasItems },
          { selector: "#cart-heading", content: null, removeInvisible: hasItems },
          { selector: ".cart__notes-wrapper", content: data["cart-important-notes"] },
          { selector: ".cart__promo-wrapper", content: data["cart-free-shipping-promo"] },
          { selector: ".cart__items-wrapper", content: data["cart-items"] }
        ];
        if (hasItems) {
          cartObject.querySelector(".cart__empty-wrapper").innerHTML = "";
          (_a2 = cartObject.querySelector(".order-summary--wrapper")) == null ? void 0 : _a2.classList.remove("invisible");
          (_b = cartObject.querySelector(".cart__items-wrapper")) == null ? void 0 : _b.classList.remove("invisible");
          updates.push({
            selector: ".order__summary-wrapper",
            content: data["cart-order-summary"]
          });
        } else {
          updates.unshift({
            selector: ".cart__empty-wrapper",
            content: data["cart-empty-msg"]
          });
          (_c = cartObject.querySelector(".cart__items-wrapper")) == null ? void 0 : _c.classList.add("invisible");
          (_d = cartObject.querySelector(".order-summary--wrapper")) == null ? void 0 : _d.classList.add("invisible");
        }
        updates.forEach(({ selector, content, removeInvisible }) => {
          const el = cartObject.querySelector(selector);
          if (el) {
            if (removeInvisible) el.classList.remove("invisible");
            if (content !== null) el.innerHTML = content;
          }
        });
        const cartItemWrapper2 = this.cartModeType.querySelector("#cart-item-wrapper");
        cartItemWrapper2 == null ? void 0 : cartItemWrapper2.classList.add("opacity-100");
        cartItemWrapper2 == null ? void 0 : cartItemWrapper2.classList.remove("opacity-50");
        const heading = cartObject.querySelector("#cart-heading");
        if (heading) {
          const count = cart2.item_count || 0;
          heading.innerHTML = count > 0 ? `Your Bag (<span class="js-cart-count" aria-live="polite">${count}</span>)` : "&nbsp;";
          _JK.Bag.item_count = count;
        }
        this.bindEvents(cartObject);
        this.applyImportantNotesShopliftTest(cartObject);
        lazyLoadImages(this.cartModeType);
      });
    });
  }
}
let cartInstance = null;
function getCartInstance(root = document) {
  if (!cartInstance) {
    cartInstance = new CartComponent(root);
    cartInstance.init();
    if (!window._JK) window._JK = {};
    window._JK.CartComponent = cartInstance;
  } else {
    if (root !== document && root !== cartInstance.cartModeType) {
      cartInstance.cartModeType = root;
      cartInstance.refreshElementRefs();
      cartInstance.refreshModalRefs();
    }
  }
  return cartInstance;
}
const cart = getCartInstance();
class ProductConfigurables {
  /**
   * Constructor
   * @param {Object}  props
   * @param {Element} productForm
   * @param {String} productContainerSection
   */
  constructor({ productForm, productSection, quickview = false }, root = document) {
    var _a;
    this.c = {
      addToBagWrapper: ".js-add-to-bag-wrapper",
      active: "is-active",
      currentSize: ".js-config-current-size",
      configHeading: ".config__heading",
      isOpen: "is-open",
      isVisible: "is-visible",
      hide: "hidden",
      hiddenId: ".js-hidden-id",
      input: ".js-input",
      notify: ".js-product-notify",
      option: ".js-option",
      optionGroup: ".js-option-group",
      price: ".js-price-original",
      priceMember: ".js-price-member",
      priceCompare: ".js-price-compare",
      pv_price: ".pv-price",
      joinMembershipButton: ".js-member-false-wrapper",
      designServicesButton: ".js-member-true-wrapper",
      preorderMessages: "#js-preorder-msg",
      quantityMessages: ".js-quantity-messages",
      submitButton: ".js-add-to-bag",
      submitButtonText: ".js-add-to-bag-text",
      validation: "text-red-100",
      shipsOn: "Expected to ship on:",
      qty: ".product-qty",
      qtyPlus: ".js-change-qty.minus",
      qtyMinus: ".js-change-qty.plus"
    };
    this.rootInstance = root;
    this.$productForm = productForm;
    this.$productSection = productSection;
    this.$currentSize = this.$productSection.querySelector(this.c.currentSize);
    this.$configHeading = this.rootInstance.querySelector(this.c.configHeading);
    this.$addToBagWrapper = this.rootInstance.querySelector(this.c.addToBagWrapper);
    this.$quickView = quickview;
    this.$hiddenId = this.$productForm.querySelector(this.c.hiddenId);
    this.$membershipbutton = this.$productSection.querySelector(this.c.joinMembershipButton);
    this.$designServicesButton = this.$productSection.querySelector(this.c.designServicesButton);
    this.$preorderMessages = this.$productForm.querySelector(this.c.preorderMessages);
    this.$quantityMessages = this.$productForm.querySelector(this.c.quantityMessages);
    this.$submitButtons = this.$productSection.querySelectorAll(this.c.submitButton);
    this.$submitButtonTexts = this.$productSection.querySelectorAll(this.c.submitButtonText);
    this.$notify = this.$productSection.querySelector(this.c.notify);
    const ShopifyTemplate = ((_a = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a.template) || "";
    this.isProductPage = [
      "product.redesign-apparel",
      "product.redesign-furniture",
      "product.redesign-home",
      "product.home",
      "product.apparel"
    ].includes(ShopifyTemplate);
    this.qtyMinus = this.$productForm.querySelector(this.c.qtyMinus);
    this.qtyPlus = this.$productForm.querySelector(this.c.qtyPlus);
    this.qtyMinusSpan = this.qtyMinus ? this.qtyMinus.querySelector("span") : null;
    this.qtyPlusSpan = this.qtyPlus ? this.qtyPlus.querySelector("span") : null;
    this.product = null;
    this.variant = null;
    this._sticky = {
      mainObserver: null,
      footerObserver: null,
      scrollHandler: null,
      initialized: false
    };
  }
  /**
   * Init
   */
  async init() {
    var _a, _b, _c;
    this.product = await this.getProductJson(
      this.$productForm.dataset.productHandle
    );
    this.productForm = new ProductForm(this.$productForm, this.product, {
      onOptionChange: async (event) => {
        await this.onFormOptionChange(event);
      }
    });
    SDG.Data.productJson = this.product;
    trackRecentlyViewed();
    this.addEventListeners();
    let variantID = "";
    if (((_b = (_a = this.product) == null ? void 0 : _a.variants) == null ? void 0 : _b.length) === 1) {
      variantID = this.product.variants[0].id;
    } else {
      const params = new URLSearchParams(window.location.search);
      variantID = params.get("variant");
    }
    if (variantID) {
      const SearchJson = SDG.Data.productJson;
      const matchingVariant = SearchJson.variants.find((variant) => variant.id === variantID);
      if (matchingVariant) {
        this.variant = matchingVariant;
      }
      this.updatePreorderMessage();
      this.updateQuantityMessage();
      if (this.$quickView === false) {
        const checkedEl = this.$productForm.querySelector('input[name="options[Size]"]:checked');
        if (checkedEl) {
          const selectedSize = checkedEl.value;
          this.updateSwatchUrlsWithSize(selectedSize);
          this.updateSwatchAvailability(selectedSize);
        }
      }
    }
    if (window.innerWidth < JSbreakpoints.mobile) {
      const isExperimentNew = (_c = document.querySelector("#stickyAddToBagWrapper")) == null ? void 0 : _c.classList.contains("sticky-exp-new");
      if (isExperimentNew) {
        this.observeStickyAddToBag(true);
      } else {
        this.observeStickyAddToBag(false);
      }
    }
    if (this.$quickView) {
      this.updatePrice();
    }
    onResizeDebounced(() => {
      var _a2;
      if (window.innerWidth < JSbreakpoints.mobile) {
        const isExperimentNew = (_a2 = document.querySelector("#stickyAddToBagWrapper")) == null ? void 0 : _a2.classList.contains("sticky-exp-new");
        if (!this._sticky.initialized) {
          this.observeStickyAddToBag(isExperimentNew);
        }
      } else {
        this.teardownStickyAddToBag();
      }
    });
  }
  /**
   * Get product JSON
   * @param {String} handle
   */
  getProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch(`/products/${handle}.js`).then((res) => res.ok ? res.json() : null).catch(() => null);
  }
  /**
   * On form option change
   * @param {Object} event
   */
  async onFormOptionChange(event) {
    var _a;
    const { variant } = event.dataset;
    this.variant = variant;
    let availability = "";
    const li = event.target.closest("li");
    if (li) {
      availability = li.dataset.availability;
    }
    this.updateActiveState();
    this.updatePrice();
    this.updateSubmitButton(availability);
    this.updateNotifyForm();
    this.updateHiddenId();
    this.updateBrowserHistory();
    this.updateQuantityMessage();
    this.updatePreorderMessage();
    this.updateAfterpayPricingMessage();
    const input = (_a = event.target) == null ? void 0 : _a.closest('input[name="options[Size]"]');
    if (input) {
      const selectedSize = input.value;
      this.updateSwatchUrlsWithSize(selectedSize);
      this.updateSwatchAvailability(selectedSize);
    }
  }
  /**
   * Observes the visibility of the primary "Add to Bag" button on the product page.
   * Displays a sticky version of the button when the original scrolls out of view,
   * unless a product notification element is visible or the main Add to Bag wrapper is hidden.
   * 
   * - Uses IntersectionObserver to track visibility of #btnAddToBag
   * - Hides sticky CTA if a notify message is shown or main CTA is hidden
   * - Fades in sticky CTA when main button is offscreen, fades out when it's visible
   */
  observeStickyAddToBag(useScrollThreshold = true) {
    const root = this.rootInstance || document;
    const targetBtn = root.querySelector("#btnAddToBag");
    const stickyWrapper = root.querySelector("#stickyAddToBagWrapper");
    const notifyEl = root.querySelector(".js-product-notify");
    const addToBagWrapper = root.querySelector(".js-add-to-bag-wrapper");
    const footer = root.querySelector(".redesign-footer");
    if (!targetBtn || !stickyWrapper) return;
    this.teardownStickyAddToBag();
    let hasPassedScrollThreshold = true;
    let scrollThreshold = 0;
    if (useScrollThreshold) {
      const thresholdEl = root.querySelector("#gallery-carousel");
      if (thresholdEl) {
        const rect2 = thresholdEl.getBoundingClientRect();
        scrollThreshold = rect2.bottom + window.scrollY - 200;
      } else {
        scrollThreshold = window.innerHeight * 0.4;
      }
      hasPassedScrollThreshold = window.scrollY > scrollThreshold;
      const handleScroll = () => {
        if (hasPassedScrollThreshold) return;
        if (window.scrollY > scrollThreshold) {
          hasPassedScrollThreshold = true;
          window.removeEventListener("scroll", handleScroll);
          this._sticky && (this._sticky.scrollHandler = null);
        }
      };
      window.addEventListener("scroll", handleScroll, { passive: true });
      if (this._sticky) this._sticky.scrollHandler = handleScroll;
    }
    addClass$1(stickyWrapper, "hidden", "opacity-0", "pointer-events-none");
    removeClass$1(stickyWrapper, "opacity-100");
    const showSticky = () => {
      removeClass$1(stickyWrapper, "hidden", "opacity-0", "pointer-events-none");
      addClass$1(stickyWrapper, "opacity-100");
      document.body.classList.add("ui-active");
    };
    const hideSticky = (keepHiddenClass = false) => {
      addClass$1(stickyWrapper, "opacity-0", "pointer-events-none");
      removeClass$1(stickyWrapper, "opacity-100");
      if (keepHiddenClass) addClass$1(stickyWrapper, "hidden");
      document.body.classList.remove("ui-active");
    };
    const mainObserver = new IntersectionObserver(
      ([entry]) => {
        const isVisible = entry.isIntersecting;
        const notifyIsVisible = notifyEl && !notifyEl.classList.contains("hidden");
        const addToBagWrapperIsHidden = addToBagWrapper && addToBagWrapper.classList.contains("hidden");
        if (notifyIsVisible || addToBagWrapperIsHidden) {
          hideSticky(true);
          return;
        }
        if (useScrollThreshold && !hasPassedScrollThreshold) {
          hideSticky(true);
          return;
        }
        if (isVisible) {
          hideSticky(true);
        } else {
          showSticky();
        }
      },
      {
        root: null,
        threshold: 0
      }
    );
    mainObserver.observe(targetBtn);
    this._sticky.mainObserver = mainObserver;
    if (footer) {
      const footerObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            hideSticky(true);
          } else if (hasPassedScrollThreshold) {
            showSticky();
          }
        },
        {
          root: null,
          threshold: 0
        }
      );
      footerObserver.observe(footer);
      this._sticky.footerObserver = footerObserver;
    }
    this._sticky.initialized = true;
  }
  /**
   * Tear down sticky observers / listeners (call when resizing to desktop, or
   * before re-initializing).
   */
  teardownStickyAddToBag() {
    const stickyWrapper = (this.rootInstance || document).querySelector("#stickyAddToBagWrapper");
    if (this._sticky.mainObserver) {
      this._sticky.mainObserver.disconnect();
      this._sticky.mainObserver = null;
    }
    if (this._sticky.footerObserver) {
      this._sticky.footerObserver.disconnect();
      this._sticky.footerObserver = null;
    }
    if (this._sticky.scrollHandler) {
      window.removeEventListener("scroll", this._sticky.scrollHandler);
      this._sticky.scrollHandler = null;
    }
    if (stickyWrapper) {
      addClass$1(stickyWrapper, "hidden", "opacity-0", "pointer-events-none");
      removeClass$1(stickyWrapper, "opacity-100");
    }
    document.body.classList.remove("ui-active");
    this._sticky.initialized = false;
  }
  /**
   * Add event listeners
   */
  addEventListeners() {
    if (this.$membershipbutton) {
      _JK.helpers.addEvent({
        id: this.$membershipbutton,
        event: "click",
        fn: this.membershipbuttons.bind(this)
      });
    }
  }
  /**
   * Update active state
   */
  updateActiveState() {
    const { options } = this.variant;
    if (!options.length) return;
    options.forEach((option, i) => {
      const optionName = this.product.options[i].name;
      const escapedOption = option.replace(/"/g, '\\"');
      const $options = [...this.$productSection.querySelectorAll(`${this.c.optionGroup}[data-option-name='${optionName}'] ${this.c.option}`)];
      const $optionsFiltered = $options.filter(($option) => $option.getAttribute("data-option-value") !== option);
      const $selectedOption = this.$productSection.querySelector(`${this.c.optionGroup}[data-option-name='${optionName}'] ${this.c.option}[data-option-value="${escapedOption}"]`);
      if (!$optionsFiltered.length) return;
      $optionsFiltered.forEach(this.deactivateOption.bind(this));
      this.activateOption($selectedOption);
    });
  }
  /**
   * Deactivate option
   * @param {Element} $option
   */
  deactivateOption($option) {
    const $input = $option.querySelector(this.c.input);
    removeClass$1($option, this.c.active);
    $input.removeAttribute("checked");
  }
  /**
   * Activate option
   * @param {Element} $option
   */
  activateOption($option) {
    const $input = $option.querySelector(this.c.input);
    const selectedSize = $input.value;
    const { isAvailable } = $input.dataset;
    addClass$1($option, this.c.active);
    $input.setAttribute("checked", "");
    this.$currentSize.innerHTML = selectedSize;
    if (hasClass$1(this.$configHeading, this.c.validation)) {
      removeClass$1(this.$configHeading, this.c.validation);
    }
    if (isAvailable === "true") {
      if (this.$configBarSelectedValue) {
        this.$configBarSelectedValue.innerHTML = selectedSize;
      }
    } else {
      const configBarSelectedHtml = `
          <strike><span class="pv-config-bar__dropdown-text">${selectedSize}</span></strike>
          <span class="pv-config-bar__waitlist-text">Waitlist</span>
        `;
      if (this.$configBarSelectedValue) {
        this.$configBarSelectedValue.innerHTML = configBarSelectedHtml;
      }
      this.$submitButtons.forEach(($submitButton) => {
        $submitButton.disabled = true;
      });
    }
    removeClass$1(this.$currentSize, this.c.validation);
    if (hasClass$1(this.$configHeading, this.c.validation)) {
      removeClass$1(this.$configHeading, this.c.validation);
      removeClass$1(this.$currentSize, this.c.validation);
    }
  }
  /**
   * Dynamically updates the pricing UI based on the currently selected variant.
   *
   * - If the product is in a QuickView context and no `this.variant` is defined yet,
   *   it attempts to determine the variant from the active `.js-option` in the form.
   * - Otherwise, it uses `this.variant.id` as the selected variant.
   * - Fetches a server-rendered pricing section based on the selected variant ID and injects
   *   the resulting HTML into all containers matching `.js-section-render-price` within `rootInstance`.
   * - This ensures accurate and up-to-date pricing for both PDP and QuickView modals, including
   *   any promotional or member pricing rendered server-side.
   */
  updatePrice() {
    let vID = "";
    if (!this.variant && this.$quickView) {
      const activeOption = this.$productForm.querySelector(".js-option.is-active");
      if (activeOption) {
        vID = activeOption.dataset.variantId;
      }
    } else {
      if (!this.variant) return;
      vID = this.variant.id;
    }
    if (!vID) return;
    const sectionUrl = `/products/${this.$productForm.dataset.productHandle}?variant=${vID}&section_id=redesign-pdp-display-pricing`;
    const rootInstance = this.rootInstance;
    fetch(sectionUrl).then((response) => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.text();
    }).then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const $priceContainers = rootInstance.querySelectorAll(".js-section-render-price");
      const $newPriceContainer = doc.querySelector(".js-section-render-price");
      $priceContainers.forEach(($container) => {
        if ($newPriceContainer) $container.innerHTML = $newPriceContainer.innerHTML;
      });
    }).catch((error) => {
      console.error("JK: An error occurred fetching variant details:", error);
    });
  }
  /**
   * Update Afterpay price messaging.
   * (currently dividing the variant price by 4) and displaying it in all elements
   * with the `.js-payment-options-amt` class. Note: Promo pricing is not supported.
   *
   * @todo Refactor to use Afterpay data attribute for calculation instead of variant price.
   *
   * @returns {void}
   */
  updateAfterpayPricingMessage() {
    const installmentInfo = this.rootInstance.querySelectorAll(".js-payment-options-amt");
    if (installmentInfo.length > 0) {
      let afterpayInstallment = this.variant.price / 4;
      installmentInfo.forEach((container) => {
        container.innerHTML = formatMoney(afterpayInstallment, "amount_with_currency");
      });
    }
  }
  /**
   * Update submit button
   */
  updateSubmitButton(availability) {
    if (!this.variant) {
      addClass$1(this.$addToBagWrapper, this.c.hide);
      this.$submitButtons.forEach(($submitButton) => {
        $submitButton.disabled = true;
      });
      this.$submitButtonTexts.forEach(($submitButtonText) => {
        $submitButtonText.innerText = "Unavailable";
      });
    } else if (this.variant.available) {
      removeClass$1(this.$addToBagWrapper, this.c.hide);
      this.$submitButtons.forEach(($submitButton) => {
        $submitButton.disabled = false;
      });
      this.$submitButtonTexts.forEach(($submitButtonText) => {
        const isQuickEdit = $submitButtonText.closest(".edit-cart__component");
        $submitButtonText.innerText = isQuickEdit ? "Update Item" : "Add to Bag";
      });
      if (availability === "preorder") {
        this.$submitButtonTexts.forEach(($submitButtonText) => {
          $submitButtonText.innerText = "Pre-order";
        });
      }
    } else {
      if (this.$quickView == false) {
        addClass$1(this.$addToBagWrapper, this.c.hide);
      }
      this.$submitButtons.forEach(($submitButton) => {
        $submitButton.disabled = true;
      });
      this.$submitButtonTexts.forEach(($submitButtonText) => {
        const isQuickEdit = $submitButtonText.closest(".edit-cart__component");
        const soldoutOrWaitlist = availability === "waitlist" ? "Join The Waitist" : "Sold Out";
        $submitButtonText.innerText = isQuickEdit ? "Update Item" : soldoutOrWaitlist;
      });
    }
  }
  /**
   * Update notify form
   */
  updateNotifyForm() {
    if (!this.$notify) return;
    if (!this.variant) {
      addClass$1(this.$notify, this.c.hide);
      return;
    }
    if (this.variant.available) {
      addClass$1(this.$notify, this.c.hide);
      if (this.qtyMinus && this.qtyPlus && this.qtyMinusSpan && this.qtyPlusSpan) {
        this.qtyMinus.disabled = false;
        this.qtyPlus.disabled = false;
        removeClass$1(this.qtyPlus, "cursor-not-allowed");
        removeClass$1(this.qtyMinus, "cursor-not-allowed");
        addClass$1(this.qtyPlusSpan, "cursor-pointer");
        addClass$1(this.qtyMinusSpan, "cursor-pointer");
      }
    } else {
      removeClass$1(this.$notify, this.c.hide);
      if (this.qtyMinus && this.qtyPlus && this.qtyMinusSpan && this.qtyPlusSpan) {
        this.qtyMinus.disabled = true;
        this.qtyPlus.disabled = true;
        addClass$1(this.qtyPlus, "cursor-not-allowed");
        addClass$1(this.qtyMinus, "cursor-not-allowed");
        removeClass$1(this.qtyPlusSpan, "cursor-pointer");
        removeClass$1(this.qtyMinusSpan, "cursor-pointer");
      }
    }
  }
  /**
   * Update hidden ID
   */
  updateHiddenId() {
    if (!this.variant) return;
    this.$hiddenId.value = this.variant.id;
  }
  /**
    * Helper function to determine if a product on a PLP
    * is eligible for a limited time promotion.
   */
  isProductPromo() {
    const MemberPromoProducts = SDG.Data.memberPromoProducts.split(",");
    const numberArray = MemberPromoProducts.map(Number);
    if (numberArray.includes(this.product.id)) {
      return true;
    }
    return false;
  }
  /**
   * Update browser history
   */
  updateBrowserHistory() {
    if (this.$quickView) {
      return;
    }
    const { enableHistoryState } = this.productForm.element.dataset;
    if (!this.variant || enableHistoryState !== "true") return;
    if (this.isProductPage) {
      const url = getUrlWithVariant(window.location.href, this.variant.id);
      window.history.replaceState({ path: url }, "", url);
    }
  }
  /**
   * Update quantity message
   */
  updateQuantityMessage() {
    const qtyMessage = this.$hiddenId.options[this.$hiddenId.selectedIndex].dataset.quantityMessage;
    if (this.$quantityMessages) this.$quantityMessages.innerHTML = qtyMessage;
  }
  /**
   * Update preorder message
   */
  updatePreorderMessage() {
    const preorderMessage = this.$hiddenId.options[this.$hiddenId.selectedIndex].dataset.preorderMessage;
    if (this.$preorderMessages) this.$preorderMessages.innerHTML = preorderMessage;
  }
  /**
    //  * Show the discover design services and hide join when someone joins membership.
    // NOTE: We will NOT switch the buttons if someone removes membership via bag overlay. Customer must refresh to see latest status.
  */
  membershipbuttons(e) {
    var _a;
    e.preventDefault();
    this.handleMembershipClick((_a = this.$membershipbutton.dataset) == null ? void 0 : _a.variantId);
    _JK.helpers.addClass(this.$membershipbutton, this.c.hide);
    _JK.helpers.removeClass(this.$designServicesButton, this.c.hide);
  }
  /**
   * handleMembershipClick
   * 
   * Adds a membership product to the cart and displays the "Add to Bag" modal.
   * 
   * - Uses a predefined variant ID representing the membership product.
   * - Adds the item with `_membership: true` in its properties for tracking.
   * - @todo: Do we need this line item property?
   * - Calls `showAddToBagModal()` with product context for modal rendering.
   * - Refreshes cart state to reflect the new item visually and functionally.
   * 
   * @param {number} variantID - The Shopify variant ID for the membership product.
   */
  async handleMembershipClick(variantID) {
    var _a, _b;
    const variantId = variantID;
    const quantity = 1;
    const properties = { _membership: true };
    const color = null;
    const currentQty = ((_b = (_a = window._JK) == null ? void 0 : _a.Bag) == null ? void 0 : _b.item_count) || 0;
    try {
      const lineItem = await cart.cart.addItem(variantId, quantity, properties);
      showAddToBagModal({
        variant: variantId,
        lineItem,
        color,
        currentQty
      });
    } catch (error) {
      console.error("Failed to add membership product:", error);
    }
  }
  /**
   * Close config bar dropdown
   */
  closeConfigBarDropdown() {
    removeClass$1(this.$configBarDropdownWrapper, this.c.isOpen);
  }
  /**
   * Is config bar dropdown open
   */
  isConfigBarDropdownOpen() {
    if (this.$configBarDropdownWrapper) {
      return hasClass$1(this.$configBarDropdownWrapper, this.c.isOpen);
    }
    return false;
  }
  /**
   * Update swatch availability using JSON availability maps
   * stored in data-size-availability on each .swatch--link
   *
   * @param {string} selectedSize - The size to check availability for
   */
  async updateSwatchAvailability(selectedSize, optionsLength = 0) {
    const swatchLinks = this.$productSection.querySelectorAll(".swatch--link");
    const currentHandle = this.$productSection.dataset.handle;
    swatchLinks.forEach((swatchLink) => {
      const handle = swatchLink.dataset.handle;
      const sizeAvailability = swatchLink.dataset.sizeAvailability;
      let isAvailable = true;
      if (sizeAvailability) {
        try {
          const sizeMap = JSON.parse(sizeAvailability);
          if (Object.keys(sizeMap).length === 1 && optionsLength === 1) {
            const firstKey = Object.keys(sizeMap)[0];
            if (sizeMap[firstKey].available === "false") isAvailable = false;
          } else {
            if (sizeMap[selectedSize]) {
              isAvailable = sizeMap[selectedSize].available === true;
            } else {
              isAvailable = false;
            }
          }
        } catch (err) {
          console.error("Invalid sizeAvailability JSON:", sizeAvailability, err);
        }
      }
      const swatch = swatchLink.querySelector(".js-swatch");
      if (swatch) {
        swatch.classList.toggle("sold-out", !isAvailable);
        if (handle === currentHandle && this.product && Array.isArray(this.product.variants)) {
          const variant = this.product.variants.find(
            (v) => v.option1 === selectedSize || v.option2 === selectedSize || v.option3 === selectedSize
          );
          if (variant) {
            this.variant = variant;
            this.updateActiveState();
            this.updatePrice();
            this.updateSubmitButton();
            this.updateNotifyForm();
            this.updateHiddenId();
          }
        }
      }
    });
  }
  /**
   * Update all swatch links to include the selected size as a URL parameter.
   *
   * @param {string} size - The currently selected size option (e.g., "S", "M").
   */
  updateSwatchUrlsWithSize(size) {
    this.$productSection.querySelectorAll(".swatch--link").forEach((swatchlink) => {
      var _a, _b;
      let variantID = null;
      if (!swatchlink.href) return;
      const sizeAvailability = (_a = swatchlink == null ? void 0 : swatchlink.dataset) == null ? void 0 : _a.sizeAvailability;
      if (sizeAvailability) {
        const sizeMap = JSON.parse(sizeAvailability);
        variantID = ((_b = sizeMap[size]) == null ? void 0 : _b.id) || null;
      }
      const url = new URL(swatchlink.href, window.location.origin);
      if (variantID) {
        url.searchParams.set("variant", variantID);
      } else {
        url.searchParams.delete("variant");
      }
      swatchlink.href = url.toString();
    });
  }
}
export {
  CartComponent as C,
  JSbreakpoints as J,
  ProductConfigurables as P,
  Splide as S,
  UniversalModal as U,
  cart as a,
  productSwatches as b,
  createLinkFromTemplate as c,
  ProductGallery as d,
  JKCart as e,
  getCartInstance as g,
  hasClass$1 as h,
  initAddToBag as i,
  lazyLoadImages as l,
  onResizeDebounced as o,
  productQty as p
};
